import { useCallback, useMemo, useState, useEffect } from "react";
import React from "react";
import {
  Box,
  Button,
  Container,
  Stack,
  SvgIcon,
  Typography,
  Grid,
  Snackbar,
  TextField,
  Modal,
  DialogTitle,
  IconButton,
  Divider,
  Paper,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import { Controller, useForm } from "react-hook-form";
import DataThresholdingIcon from "@mui/icons-material/DataThresholding";
import ReactSelect from "react-select";
import InputMask from "react-input-mask";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { useAlert } from "react-alert";
import { useNavigate } from "react-router-dom";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Moment from "moment";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import VOBPAGE1 from "./Vobpage1";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import PermIdentity from "@mui/icons-material/PermIdentity";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import EligibilityCheck from "./EligibilityCheck";
import InsuranceplanRegistration from "./InsuranceplanRegistration";
import { DataGrid } from "@mui/x-data-grid";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import { useSelector } from "react-redux";
import ContantsRegistration from "./ContantsRegistration";

const Demographics = (props) => {
  // document.title = "Demographics | LuxBillingEHR";
  const rights = useSelector((state) => state.login.rights);

  const fields = [
    "id",
    "accountNumber",
    "lastName",
    "firstName",
    "midInitial",
    "title",
    "alias",
    "ssn",
    "dob",
    "gender",
    "status",
    "cellNo",
    "language",
    "maritalStatus",
    "homePhone",
    "cellPhone",
    "workPhone",
    "emailAddress",
    "city",
    "state",
    "zipCode",
    "address",
    "photoUrl",
    "comments",
    "practiceId",
    "isActive",
    "updatedBy",
    "updatedDate",
    "createdBy",
    "createdDate",
    "providerId",
    "facilityId",
    "careTeam_id",
    "estimatedMonthlyTime",
    "assignedTo",
    "dueDate",
    "careManagementStatus",
    "intakeStatus",
    "diagnosis1",
    "diagnosis2",
    "lastCommunicatedDate",
    "patientStarted",
    "salesRep",
    "socialWorker",
    "referralSource",
    "dischargeDate",
    "hmo",
    "ppo",
    "medicareStatus",
    "frequencyOfContact",
    "careManager",
    "leadCareManager",
    "intakeCoordinator",
    "inactiveDate",
    "initialVisitDate",
    "carePlanStatus",
    "additionalContactInfo",
    "pcpDoctorInfo",
    "careManagerSupervisor",
  ];
  var defaultValues = {
    priIns: {
      id: 0,
      insuranceId: "",
      patientId: "",
      groupId: "",
      memberId: "",
      practiceId: "",
      payerId: "",
      type: "primary",
      copay: "",
      deductible: "",
      subsRelation: "Self",
      subsFirtName: "",
      subsLastName: "",
      guarranterName: "",
      guarantorAddress: "",
      guarantorSuite: "",
      guarantorCity: "",
      guarantorState: "",
      guarantorZip: "",
      inactive: "",
      startDate: "",
      endDate: "",
      createdDate: "",
      updatedDate: "",
      createdBy: "",
      updatedBy: "",
      clientCreatedDate: "",
      clientUpdatedDate: "",
    },
    id: 0,
    accountNumber: "",
    lastName: "",
    firstName: "",
    midInitial: "",
    title: "",
    alias: "",
    ssn: "",
    dob: "",
    gender: "",
    status: "",
    cellNo: "",
    language: "",
    maritalStatus: "",
    homePhone: "",
    cellPhone: "",
    workPhone: "",
    emailAddress: "",
    city: "",
    state: "",
    zipCode: "",
    address: "",
    photoUrl: "",
    program: "",
    smokingStatus: "",
    comments: "",
    practiceId: "",
    facilityId: "",
    providerId: "",
    isActive: "",
    updatedBy: "",
    updatedDate: "",
    createdBy: "",
    createdDate: "",
    base64: "",
    secIns: {
      id: 0,
      insuranceId: "",
      patientId: "",
      groupId: "",
      memberId: "",
      practiceId: "",
      payerId: "",
      type: "secondary",
      copay: "",
      deductible: "",
      subsRelation: "Self",
      subsFirtName: "",
      subsLastName: "",
      guarranterName: "",
      guarantorAddress: "",
      guarantorSuite: "",
      guarantorCity: "",
      guarantorState: "",
      guarantorZip: "",
      inactive: "",
      startDate: "",
      endDate: "",
      createdDate: "",
      updatedDate: "",
      createdBy: "",
      updatedBy: "",
      clientCreatedDate: "",
      clientUpdatedDate: "",
    },
    triIns: {
      id: 0,
      insuranceId: "",
      patientId: "",
      groupId: "",
      memberId: "",
      practiceId: "",
      payerId: "",
      type: "tertiary",
      copay: "",
      deductible: "",
      subsRelation: "Self",
      subsFirtName: "",
      subsLastName: "",
      guarranterName: "",
      guarantorAddress: "",
      guarantorSuite: "",
      guarantorCity: "",
      guarantorState: "",
      guarantorZip: "",
      inactive: "",
      startDate: "",
      endDate: "",
      createdDate: "",
      updatedDate: "",
      createdBy: "",
      updatedBy: "",
      clientCreatedDate: "",
      clientUpdatedDate: "",
    },
  };
  function resetAfterAPICall(value) {
    var data = {
      id: value.id,
      accountNumber: value.accountNumber,
      lastName: value.lastName,
      firstName: value.firstName,
      midInitial: value.midInitial,
      title: value.title,
      alias: value.alias,
      ssn: value.ssn,
      dob: value.dob,
      gender: value.gender,
      status: value.status,
      cellNo: value.cellNo,
      language: value.language,
      maritalStatus: value.maritalStatus,
      homePhone: value.homePhone,
      cellPhone: value.cellPhone,
      workPhone: value.workPhone,
      emailAddress: value.emailAddress,
      city: value.city,
      state: value.state,
      zipCode: value.zipCode,
      address: value.address,
      photoUrl: value.photoUrl,
      program: value.program,
      smokingStatus: value.smokingStatus,
      comments: value.comments,
      practiceId: value.practiceId,
      facilityId: value.facilityId,
      careTeam_id: value.careTeam_id,
      providerId: value.providerId,
      isActive: value.isActive,
      updatedBy: value.updatedBy,
      updatedDate: value.updatedDate,
      createdBy: value.createdBy,
      createdDate: value.createdDate,
      base64: value.base64,
      priIns: {},
      secIns: {},
    };
    if (
      value.priIns !== undefined &&
      value.priIns !== null &&
      value.priIns.id > 0
    ) {
      var _priIns = {
        id: value.priIns.id,
        insuranceId: value.priIns.insuranceId,
        planName: value.priIns.planName,
        patientId: value.priIns.patientId,
        groupId: value.priIns.groupId,
        memberId: value.priIns.memberId,
        insuranceType: value.priIns.insuranceType,
        practiceId: value.priIns.practiceId,
        payerId: value.priIns.payerId,
        type: value.priIns.typerimary,
        copay: value.priIns.copay,
        deductible: value.priIns.deductible,
        subsRelation: value.priIns.subsRelation || "Self",
        subsFirtName: value.priIns.subsFirtName,
        subsLastName: value.priIns.subsLastName,
        guarranterName: value.priIns.guarranterName,
        guarantorAddress: value.priIns.guarantorAddress,
        guarantorSuite: value.priIns.guarantorSuite,
        guarantorCity: value.priIns.guarantorCity,
        guarantorState: value.priIns.guarantorState,
        guarantorZip: value.priIns.guarantorZip,
        inactive: value.priIns.inactive,
        startDate: Moment(value.priIns.startDate).format("YYYY-MM-DD"),
        endDate: Moment(value.priIns.endDate).format("YYYY-MM-DD"),
        createdDate: value.priIns.createdDate,
        updatedDate: value.priIns.updatedDate,
        createdBy: value.priIns.createdBy,
        updatedBy: value.priIns.updatedBy,
        clientCreatedDate: value?.priIns?.clientCreatedDate || "",
        clientUpdatedDate: value?.priIns?.clientUpdatedDate || "",
      };
      data.priIns = _priIns;
    } else {
      data.priIns = defaultValues.priIns;
    }
    if (
      value.secIns != undefined &&
      value.secIns != null &&
      value.secIns.id > 0
    ) {
      var _secIns = {
        id: value.secIns.id,
        insuranceId: value.secIns.insuranceId,
        planName: value.secIns.planName,
        patientId: value.secIns.patientId,
        groupId: value.secIns.groupId,
        memberId: value.secIns.memberId,
        insuranceType: value.secIns.insuranceType,
        practiceId: value.secIns.practiceId,
        payerId: value.secIns.payerId,
        type: value.secIns.type,
        copay: value.secIns.copay,
        deductible: value.secIns.deductible,
        subsRelation: value.secIns.subsRelation || "Self",
        subsFirtName: value.secIns.subsFirtName,
        subsLastName: value.secIns.subsLastName,
        guarranterName: value.secIns.guarranterName,
        guarantorAddress: value.secIns.guarantorAddress,
        guarantorSuite: value.secIns.guarantorSuite,
        guarantorCity: value.secIns.guarantorCity,
        guarantorState: value.secIns.guarantorState,
        guarantorZip: value.secIns.guarantorZip,
        inactive: value.secIns.inactive,
        startDate: Moment(value.secIns.startDate).format("YYYY-MM-DD"),
        endDate: Moment(value.secIns.endDate).format("YYYY-MM-DD"),
        createdDate: value.secIns.createdDate,
        updatedDate: value.secIns.updatedDate,
        createdBy: value.secIns.createdBy,
        updatedBy: value.secIns.updatedBy,
        clientCreatedDate: value?.secIns?.clientCreatedDate || "",
        clientUpdatedDate: value?.secIns?.clientUpdatedDate || "",
      };
      data.secIns = _secIns;
    } else {
      data.secIns = defaultValues.secIns;
    }

    if (
      value.triIns != undefined &&
      value.triIns != null &&
      value.triIns.id > 0
    ) {
      var _triIns = {
        id: value.triIns.id,
        insuranceId: value.triIns.insuranceId,
        planName: value.triIns.planName,
        patientId: value.triIns.patientId,
        groupId: value.triIns.groupId,
        memberId: value.triIns.memberId,
        insuranceType: value.triIns.insuranceType,
        practiceId: value.triIns.practiceId,
        payerId: value.triIns.payerId,
        type: value.triIns.type,
        copay: value.triIns.copay,
        deductible: value.triIns.deductible,
        subsRelation: value.triIns.subsRelation || "Self",
        subsFirtName: value.triIns.subsFirtName,
        subsLastName: value.triIns.subsLastName,
        guarranterName: value.triIns.guarranterName,
        guarantorAddress: value.triIns.guarantorAddress,
        guarantorSuite: value.triIns.guarantorSuite,
        guarantorCity: value.triIns.guarantorCity,
        guarantorState: value.triIns.guarantorState,
        guarantorZip: value.triIns.guarantorZip,
        inactive: value.triIns.inactive,
        startDate: Moment(value.triIns.startDate).format("YYYY-MM-DD"),
        endDate: Moment(value.triIns.endDate).format("YYYY-MM-DD"),
        createdDate: value.triIns.createdDate,
        updatedDate: value.triIns.updatedDate,
        createdBy: value.triIns.createdBy,
        updatedBy: value.triIns.updatedBy,
        clientCreatedDate: value?.triIns?.clientCreatedDate || "",
        clientUpdatedDate: value?.triIns?.clientUpdatedDate || "",
      };
      data.triIns = _triIns;
    } else {
      data.triIns = defaultValues.triIns;
    }
    const deepCopy = JSON.parse(JSON.stringify(data));
    reset(deepCopy);
  }
  const token = localStorage.getItem("Token");
  const UserType = localStorage.getItem("User_Type");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const navigate = useNavigate();

  const alert = useAlert();
  const patientId = props.patientid;
  const [zipDownloaded, setzipDownloaded] = useState(false);
  const [openPracMenu, setOpenPracMenu] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [fetchedData, setfetchedData] = useState(false);
  const [CareTeamList, setCareTeamList] = useState([]);
  const [lastName, setLastName] = useState("");
  const [fName, setFirstName] = useState("");
  const [apiError, setApiError] = useState("");
  const [assigned, setassignedTo] = useState("");
  const [insuranceNames, setinsuranceNames] = React.useState([]);
  const [openInsurances, setOpenInsurances] = useState(0);
  const [open, setOpen] = React.useState(false);
  const [zipCodeList, setZipCodeList] = React.useState([]);
  const today = new Date();
  var startDate = new Date();
  startDate.setFullYear(startDate.getFullYear() - 150);
  const validationSchema = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    address: Yup.string().required("Address is required"),
    gender: Yup.string().required("Gender is required"),
    zipCode: Yup.string()
      .required("Zip Code is required")
      .matches(/^\d{5}$/, "Zip Code must be exactly 5 digits"),
    status: Yup.string().required("Status is required"),
    city: Yup.string()
      .required("City is required")
      .matches(
        /^[A-Za-z\s-]+$/,
        "City can only contain letters, spaces, and hyphens",
      ),
    state: Yup.string().required("State is required"),
    dob: Yup.date()
      .required("dob is required")
      .nullable()
      .transform((v) => (v instanceof Date && !isNaN(v) ? v : null))
      .max(today, "You can't be born in the future!")
      .min(startDate, "You can't be that much old!"),
  });
  const {
    register,
    control,
    handleSubmit,
    setValue,
    reset,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    resolver: yupResolver(validationSchema),
    defaultValues,
  });

  function handleCancel() {
    if (props.Authorization === "Authorization") {
      props.handleClosepatientreg.props.children();
    } else {
      navigate("/Patient");
    }
  }
  const [phone, setPhone] = React.useState();
  const [duedate, setDuedate] = React.useState();
  // const [inactiveDate, setinactiveDate] = React.useState();
  // const [initialVisitDate, setinitialvisitDate] = React.useState();
  // const [LastCommunicatedDate, setLastCommunicatedDate] = React.useState();
  // const [DischargeDate, setDischargeDate] = React.useState();
  const [Dob, setDob] = React.useState(Moment().format("YYYY-MM-DD"));
  const [cellPhone, setcellPhone] = React.useState();
  const [workPhone, setworkPhone] = React.useState();
  const [disable, setdisable] = React.useState(false);
  const [email, setemail] = React.useState();
  const [insuranceError, setInsuranceError] = React.useState(false);
  const [ssN, setssn] = React.useState();
  const [insuranceErrors, setInsuranceErrors] = useState({});
  const onSubmit = (data) => {

//  const isEditMode = patientId !== undefined && patientId !== null;

  // if (!isEditMode) {
  //   const insuranceTypes = [
  //     { key: "priIns", label: "Primary Insurance" },
  //     { key: "secIns", label: "Secondary Insurance" },
  //     { key: "triIns", label: "Tertiary Insurance" },
  //   ];

  //   let errorsObj = {};

  //   insuranceTypes.forEach((ins) => {
  //     const insurance = data?.[ins.key];

  //     if (insurance?.planName) {
  //       if (!insurance?.payerId?.trim()) {
  //         errorsObj[`${ins.key}.payerId`] = "Payer Id is required";
  //       }

  //       if (!insurance?.memberId?.trim()) {
  //         errorsObj[`${ins.key}.memberId`] = "Member Id is required";
  //       }
  //     }
  //   });

  //   if (Object.keys(errorsObj).length > 0) {
  //     setInsuranceErrors(errorsObj);
  //     return; // ❌ Stop submit
  //   }
  // // }

  // setInsuranceErrors({});

const referringPhysiciansPayload = [
  data.primaryReferringPhysician,
  data.secondaryReferringPhysician
]
  .filter(Boolean) 
  .map(item => ({
    id: item?.id || 0,
    referringPhysicianId: item?.referringPhysicianId,
    patientId: patientId,
    inactive: false
  }));
    if (data.dob != undefined && data.dob != null)
      data.dob = data.dob.toLocaleString();

    setSubmitting(true);
    setdisable(true);
    const postData = {
      ...data,
      dob: Dob,
      priIns: {
        ...defaultValues.priIns,
        ...data.priIns,
        type: "primary",
      },
      secIns: {
        ...defaultValues.secIns,
        ...data.secIns,
      },
      triIns: {
        ...defaultValues.triIns,
        ...data.triIns,
      },
     referringPhysicians: referringPhysiciansPayload
    };
    if (Self == true) {
      postData.priIns.subsLastName = postData.lastName;
      postData.priIns.subsFirtName = postData.firstName;
    }

    if (Selected == true) {
      postData.secIns.subsLastName = postData.lastName;
      postData.secIns.subsFirtName = postData.firstName;
    }
    if (patientId !== undefined && patientId != null)
      postData.id = parseInt(patientId);
    axios
      .post(`${process.env.REACT_APP_API_URL}/Patients/addPatient`, postData, {
        headers,
      })
      .then((response) => {
        setSubmitting(false);
        //   alert.success("Record saved successfully", {
        //     type: "success",
        //     onClose: () => {
        //       if (props.callingFrom == "Patient") {
        //         props.handleClosepatientdem();
        //       } else if (props.callingFrom == true) {
        //         props.handleClosepatientreg();
        //       } else {
        //         navigate("/Patient");
        //       }
        //       setdisable(false);
        //     },
        //   });
        // } else if (props.callingFrom == "dashboard") {
        //   props.CloseModal();
        // } else {
        //   setSubmitting(false);
        //   setdisable(false);
        //   navigate("/Patient");
        // }
        Swal.fire({
          icon: "success",
          title: "Record saved successfully",
          timer: 2000, // auto close
          showConfirmButton: false,
          willClose: () => {
            // ❌ Do not call any functions, just return null
            return null;
          },
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) {
              swalPopup.style.zIndex = 5000;
              const swalContent = swalPopup.querySelector(".swal2-popup");
              if (swalContent) swalContent.style.zIndex = 5001;
            }
          },
        });
        if (props.callingFrom == "Patient" || props.callingFrom == true) {
          // props.CloseModal(); // This is allowed
          return null;
        } else {
          setSubmitting(false);
          setdisable(false);
          navigate("/Patient");
        }
      })
      .catch((error) => {
        setSubmitting(false);
        setdisable(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Error: ${error.message}`,
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) {
              swalPopup.style.zIndex = 5000;
              const swalContent = swalPopup.querySelector(".swal2-popup");
              if (swalContent) swalContent.style.zIndex = 5001;
            }
          },
        });
      });
  };
  const onchangeinsurce = async (value) => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/Insurances/getInsuranceByName?Name=${value}`,
        { headers },
      )
      .then((response) => {
        setOpenInsurances(true);
        setinsuranceNames(response);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  const [Selected, setSelected] = useState(false);
  const [PfirstName, setPfirstName] = useState("");
  const [PLastName, setpLastName] = useState("");
  const [Self, setSelf] = useState(false);

  useEffect(() => {
    if (patientId > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Patients/getPatientById?id=${
            patientId !== undefined ? patientId : 0
          }`,
          { headers },
        )
        .then((response) => {
          resetAfterAPICall(response);
          setzipDownloaded(true);
               const physicians = response.referringPhysicians || [];
            const primary = physicians[0] || null;
            const secondary = physicians[1] || null;
            setValue("primaryReferringPhysician", primary);
            setValue("secondaryReferringPhysician", secondary);
          setPhone(response.homePhone);
          setcellPhone(response.cellPhone);
          setworkPhone(response.workPhone);
          setPfirstName(response.firstName);
          setpLastName(response.lastName);
          setssn(response.ssn);
          var dateYMD = Moment(response.dob).format("YYYY-MM-DD");
          setDob(dateYMD);
          var duedateYMD = Moment(response.dueDate).format("YYYY-MM-DD");
          setDuedate(duedateYMD);
          setemail(response.emailAddress);
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  }, [patientId]);
  const [tabValueIns, settabValueIns] = React.useState(0);
  const handleChangeInsurances = (event, newValue) => {
    settabValueIns(newValue);
  };
  const zipCodeListStyle = {
    cursor: "pointer",
    "&:hover": {
      background: "#3b3b3b !important",
      color: "rgba(5, 152, 236, 0.637) !important",
    },
  };
  const [radioValue, setradioValue] = useState("3");
  const optionChange5 = (event) => {};
  const [openModalEligiblity, setopenModalEligiblity] = useState(false); // Modal state
  const memberIdMap = {
    0: watch("priIns.memberId"),
    1: watch("secIns.memberId"),
    2: watch("triIns.memberId"),
  };

  const memberId = memberIdMap[tabValueIns];
  const RelationFirstNameMap = {
    0: watch("priIns.subsFirtName"),
    1: watch("secIns.subsFirtName"),
    2: watch("triIns.subsFirtName"),
  };

  // Map last names
  const RelationLastNameMap = {
    0: watch("priIns.subsLastName"),
    1: watch("secIns.subsLastName"),
    2: watch("triIns.subsLastName"),
  };

  // Map relations
  const RelationMap = {
    0: watch("priIns.subsRelation"),
    1: watch("secIns.subsRelation"),
    2: watch("triIns.subsRelation"),
  };

  // Only set first and last names if relation is NOT 'Self'
  let RelationfirstName = "";
  let RelationLasttName = "";

  if (RelationMap[tabValueIns] !== "Self") {
    RelationfirstName = RelationFirstNameMap[tabValueIns];
    RelationLasttName = RelationLastNameMap[tabValueIns];
  }

  const handleOpenEligiblity = () => {
    setopenModalEligiblity(true);
  };

  const handleCloseEligiblity = () => {
    setopenModalEligiblity(false);
  };
  const [OpenNewInsurance, setOpenNewInsurance] = useState(false); // Modal state

  const handleOpenNewInsurance = () => {
    setOpenNewInsurance(true);
  };

  const handleCloseNewInsurance = () => {
    setOpenNewInsurance(false);
  };
  const [rows, setRows] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [eligibilityDetail, setEligibilityDetail] = useState(null);
  const [benefits, setBenefits] = useState([]);

  // const getBenefitType = (item) => {
  //   const coverage = item.benefit_coverage_description?.toLowerCase() || "";
  //   const code = item.benefit_code;

  //   if (coverage.includes("out of pocket") || coverage.includes("stop loss")) {
  //     return "deductible";
  //   }

  //   if (coverage.includes("deductible") || ["C", "29"].includes(code)) {
  //     return "deductible";
  //   }

  //   return "benefit";
  // };

// ===== Helper: Determine benefit type =====
const getBenefitType = (item) => {
  const coverage = item.benefit_coverage_description?.toLowerCase() || "";
  const code = item.benefit_code;

  // Deductible + OOP
  if (
    coverage.includes("out of pocket") ||
    coverage.includes("stop loss") ||
    coverage.includes("deductible") ||
    ["C", "29"].includes(code)
  ) {
    return "deductible";
  }

  // Copay / Coinsurance
  if (
    coverage.includes("co-payment") ||
    coverage.includes("copayment") ||
    coverage.includes("copay") ||
    coverage.includes("co-insurance") ||
    coverage.includes("coinsurance") ||
    ["A", "B"].includes(code)
  ) {
    return "coinsurance";
  }

  // Active coverage / others
  return "benefit";
};


// ===== Helper: Relevant Benefit =====
const isRelevantBenefit = (b) => {
  const coverage = b.benefit_coverage_description?.toLowerCase() || "";

  // ❌ Ignore pure info / directory type rows
  if (
    coverage.includes("unknown") ||
    coverage.includes("contact") ||
    b.entity_description ||
    b.entity_name
  ) {
    return false;
  }

  // ✅ Active Coverage hamesha relevant hai
  if (coverage.includes("active coverage")) {
    return true;
  }

  // ✅ Financial value wali cheez
  return (
    (b.benefit_amount && b.benefit_amount > 0) ||
    (b.benefit_percent && b.benefit_percent > 0) ||
    !!b.benefit_notes
  );
};


// ===== Merge duplicates by key =====
const mergeBenefits = (benefits) => {
  const map = {};

  benefits.forEach((b) => {
    if (!isRelevantBenefit(b)) return;

    const key = [
      b.benefit_code,
      b.benefit_description,
      b.benefit_coverage_description,
      b.benefit_notes,
      b.insurance_type_description,
      b.benefit_level_code,
      b.inplan_network,
    ]
      .map((v) => v || "")
      .join("|");

    if (!map[key]) {
      map[key] = {
        ...b,
        periods: {},
      };
    }

    // 🔁 Period-wise merge (safe)
    if (b.benefit_period_description) {
      const period = b.benefit_period_description;

      // Agar same period dobara aaye to overwrite nahi kare
      if (!map[key].periods[period]) {
        map[key].periods[period] = {
          // amount: b.benefit_amount || 0,
          // percent: b.benefit_percent || 0,
          amount: b.benefit_amount != null ? b.benefit_amount : 0,
percent: b.benefit_percent != null ? b.benefit_percent : 0,

        };
      }
    }
  });

  return Object.values(map);
};


// ===== Process Benefits =====
const getDeductiblePriority = (item) => {
  const coverage = (item.benefit_coverage_description || "").toLowerCase();
  const level = (item.benefit_level_description || "").toLowerCase();
  if (level.includes("ind")) return 1;
  if (level.includes("fam")) return 2;
  if (coverage.includes("out of pocket")) return 3;
  return 4;
};
const getDeductibleType = (item) => {
  const level = (item.benefit_level_description || "").toLowerCase();
  const coverage = (item.benefit_coverage_description || "").toLowerCase();

  if (coverage.includes("out of pocket")) return "OOP";
  if (level.includes("ind")) return "Individual";
  if (level.includes("fam")) return "Family";

  return "Unknown";
};

const getNetworkCategory = (item) => {
  const net = item.inplan_network;

  if (net === "Y") return "IN";
  if (net === "N") return "OON";
  if (net === "W") return "CONDITIONAL";

  return "UNKNOWN";
};


const mergedBenefits = mergeBenefits(benefits);

const deductibleBenefits = mergedBenefits
  .filter((b) => getBenefitType(b) === "deductible")
  .sort((a, b) => getDeductiblePriority(a) - getDeductiblePriority(b));
const individualDeductibles = deductibleBenefits.filter(
  (item) => getDeductibleType(item) === "Individual"
);

const familyDeductibles = deductibleBenefits.filter(
  (item) => getDeductibleType(item) === "Family"
);

const oopMaxDeductibles = deductibleBenefits.filter(
  (item) => getDeductibleType(item) === "OOP"
);

const coInsuranceBenefits = mergedBenefits.filter(
  (b) => getBenefitType(b) === "coinsurance"
);
const inNetworkCoinsurance = coInsuranceBenefits.filter(
  (b) => getNetworkCategory(b) === "IN"
);

const outOfNetworkCoinsurance = coInsuranceBenefits.filter(
  (b) => getNetworkCategory(b) === "OON"
);

const conditionalNetworkCoinsurance = coInsuranceBenefits.filter(
  (b) => getNetworkCategory(b) === "CONDITIONAL"
);
const patientBenefits = mergedBenefits.filter(
  (b) => getBenefitType(b) === "benefit"
);

  const getNetworkLabel = (value) => {
    if (value == "Y") return "In-Network";
    if (value == "N") return "Out-of-Network";
    if (value == "W") return "Conditional Network";
    return "Unknown";
  };
  // Determine Deductible Type


  // Deductible color based on type
  const getDeductibleColor = (item) => {
    const type = getDeductibleType(item);
    if (type === "Family") return "#f87171"; // Red
    if (type === "Individual") return "#d26c12"; // Yellow
    if (
      (item.benefit_coverage_description || "")
        .toLowerCase()
        .includes("out of pocket")
    )
      return "#3b82f6"; // Blue for OOP
    return "#d1d5db"; // Default gray
  };

  const [detailLoading, setDetailLoading] = useState(false);
  useEffect(() => {
    const fetchEligibilityData = async () => {
      if (patientId > 0) {
        setLoading(true);
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/Eligibility/GetEligibilitybyId?pId=${patientId}`,
            { headers },
          );
          setRows(response || []);
          if (response.length > 0) {
            fetchEligibilityDetail(response[0].id);
          }
        } catch (err) {
        } finally {
          setLoading(false);
        }
      }
    };

    fetchEligibilityData();
  }, [patientId, openModalEligiblity]);

  const fetchEligibilityDetail = async (eligibilityId) => {
    setDetailLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/Eligibility/getEligibility&BenfitsById?PatienteligibityId=${eligibilityId}`,
        { headers },
      );

      setEligibilityDetail(res);
      setBenefits(res?.patientBenefits || []);
    } catch (err) {
      console.error(err);
    } finally {
      setDetailLoading(false);
    }
  };

  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    minHeight: "5px !important",
    background: "drak",
    fontSize: "13.4px !important",
    color: "drak !important",
    borderColor: "#326C1D",
    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637) !important",
      fontSize: "14.6px !important",
    },
    "&.MuiDataGrid-root .custom-column-header .MuiDataGrid-colCellTitle": {
      lineHeight: "20px !important", // Adjust this value to decrease the header height
    },
    "& .super-app-theme--header": {
      backgroundColor: "#377562",
      borderRadius: 0.1,
      color: "white",
      fontSize: "16px !important",
      // minHeight:'5px !important'

      // height: '35px !important',
    },
  };
  const gridClasses = {
    columnHeader: "MuiDataGrid-columnHeaders",
  };
  const columns = [
    {
      field: "eligid",
      headerName: "Elig Id",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
    },
    {
      field: "ins_name_l",
      headerName: "Last Name",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
    },

    {
      field: "ins_name_f",
      headerName: "First Name",
      headerClassName: "super-app-theme--header",
      flex: 0.1,
    },
    ,
    {
      field: "ins_number",
      headerName: "Ins number",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
    },
    {
      field: "ins_sex",
      headerName: "Ins sex",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
    },
    {
      field: "ins_state",
      headerName: "Ins state",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
    },
    {
      field: "eligibility_date",
      headerName: "Eligibility date",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
    },
  ];
  // reffering physican 
    const [referringPhysicianName, setreferringPhysicianName] = useState([]);
    const practiceID = localStorage.getItem("default_paractice");
    const selectedIds = watch("referringPhysicians");
    const [OpenNewProvider, setOpenNewProvider] = useState(false); // Modal state
    const handleOpenNewProvider = () => {
        setOpenNewProvider(true);
      };
    const handleCloseNewProvider = () => {
      setOpenNewProvider(false);
    };
    useEffect(() => {
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/ReferringPhysicians/ReferringPhysicians?parcticeid=${practiceID}`,
            { headers }
          )
          .then((response) => {
            var rprov = [];
            response.forEach((field) => {
              rprov.push({
                 label: `${field.lastName},${field.firstName} — NPI: ${field.npi} `,
                value: field.id,
              });
            });
            setreferringPhysicianName(rprov);
          })
          .catch((error) => {});
    }, [practiceID,OpenNewProvider]);

  return (
    <React.Fragment>
      <Modal
              open={OpenNewProvider}
              onClose={handleCloseNewProvider}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              sx={{ zIndex: "1800" }}
            >
              <ContantsRegistration
                callingFrom={"Documents"}
                handleCloseProviderModal={handleCloseNewProvider}
              ></ContantsRegistration>
            </Modal>
      <Modal
        open={openModalEligiblity}
        onClose={handleCloseEligiblity}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: "1800" }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "54%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "80%", sm: "70%", md: "70%" },
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            // p: 3,
            maxHeight: "80vh",
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
        >
          {/* <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
            sx={{
              backgroundColor: "#E9F5EF",
              borderRadius: "12px",
              padding: "0.6rem 1rem",
              boxShadow: "0 2px 4px rgba(55,117,98,0.25)",
            }}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: "#00695C",
                letterSpacing: "0.5px",
                fontSize: { xs: "1rem", sm: "1.1rem" },
              }}
            >
              Eligibility Request
            </Typography>

            <IconButton
              onClick={handleCloseEligiblity}
              sx={{
                color: "#00695C", // dark teal for icon
                backgroundColor: "#C6F3DD", // minty soft green background
                transition: "0.3s",
                "&:hover": { backgroundColor: "#00695C", color: "#FFFFFF" }, // inverted hover
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box> */}

          {/* <Divider sx={{ mb: 2 }} /> */}

          <Box>
            <Grid item xs={12}>
              <EligibilityCheck
                LastName={PLastName}
                firstName={PfirstName}
                patientId={patientId}
                memberId={memberId}
                SubLastName={RelationLasttName}
                SubfirstName={RelationfirstName}
                Dob={Dob}
                handleCancel={handleCloseEligiblity}
              />
            </Grid>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={OpenNewInsurance}
        onClose={handleCloseNewInsurance}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: "1800" }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "54%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95%", sm: "90%", md: "80%" },
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            p: 3,
            maxHeight: "80vh",
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
        >
          {/* <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
            sx={{
              backgroundColor: "#E9F5EF",
              borderRadius: "12px",
              padding: "0.6rem 1rem",
              boxShadow: "0 2px 4px rgba(55,117,98,0.25)",
            }}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: "#00695C",
                letterSpacing: "0.5px",
                fontSize: { xs: "1rem", sm: "1.1rem" },
              }}
            >
              Add New Insurance
            </Typography>

            <IconButton
              onClick={handleCloseNewInsurance}
              sx={{
                color: "#00695C", // dark teal for icon
                backgroundColor: "#C6F3DD", // minty soft green background
                transition: "0.3s",
                "&:hover": { backgroundColor: "#00695C", color: "#FFFFFF" }, // inverted hover
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box> */}

          {/* <Divider sx={{ mb: 2 }} /> */}

          <Box>
            <Grid item xs={12} style={{ marginTop: "-50px" }}>
              {/* <EligibilityCheck  LastName={PLastName} firstName={PfirstName} patientId={patientId} handleCancel={handleCloseNewInsurance}   /> */}
              <InsuranceplanRegistration
                callingFrom={"Demographic"}
                handleCancel={handleCloseNewInsurance}
              />
            </Grid>
          </Box>
        </Box>
      </Modal>

      <div className="page-content" style={{ marginTop: "-100px" }}>
        <Grid container columnSpacing={1}>
          <Grid item xs={4}>
            <Typography component="label" color="black">
              Email address
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography component="label" color="black">
              Last Name
            </Typography>
            <label
              style={{ fontWeight: "bold", color: "red", fontSize: "15px" }}
            >
              *
            </label>
          </Grid>
          <Grid item xs={4}>
            <Typography component="label" color="black">
              First Name
            </Typography>
            <label
              style={{ fontWeight: "bold", color: "red", fontSize: "15px" }}
            >
              *
            </label>
          </Grid>
          <Grid item xs={4}>
            <Controller
              name="emailAddress"
              {...register("emailAddress")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  fullWidth
                  {...field}
                  style={{ backgroundColor: "white" }}
                  name="email"
                  type="email"
                />
              )}
            />
          </Grid>
          <Grid item xs={4}>
            <Controller
              name="lastName"
              {...register("lastName")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  {...field}
                  type="text"
                  value={PLastName ? PLastName.toUpperCase() : ""}
                  onChange={(e) => {
                    const uppercaseValue = e.target.value.toUpperCase();
                    setValue("lastName", uppercaseValue);
                    setpLastName(uppercaseValue);
                  }}
                  error={errors.lastName}
                />
              )}
            />
            <p style={{ color: "red", fontSize: "14px" }}>
              {errors.lastName?.message}
            </p>
          </Grid>
          <Grid item xs={4}>
            <Controller
              name="firstName"
              {...register("firstName")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  style={{ backgroundColor: "white" }}
                  fullWidth
                  {...field}
                  type="text"
                  value={PfirstName ? PfirstName.toUpperCase() : ""}
                  onChange={(e) => {
                    const uppercaseValue = e.target.value.toUpperCase();
                    setValue("firstName", uppercaseValue);
                    setPfirstName(uppercaseValue);
                  }}
                  error={errors.firstName}
                />
              )}
            />

            <p style={{ color: "red", fontSize: "14px" }}>
              {errors.firstName?.message}
            </p>
          </Grid>
          <Grid item xs={4}>
            <Typography component="label" color="black">
              DOB
            </Typography>
            <label
              style={{ fontWeight: "bold", color: "red", fontSize: "15px" }}
            >
              *
            </label>
          </Grid>
          <Grid item xs={4}>
            <Typography component="label" color="black">
              Gender
            </Typography>
            <label
              style={{ fontWeight: "bold", color: "red", fontSize: "15px" }}
            >
              *
            </label>
          </Grid>

          <Grid item xs={4}>
            <Typography htmlFor="phone-number" component="label" color="black">
              SSN
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Controller
              name="dob"
              control={control}
              render={({ field }) => (
                <TextField
                  type="date"
                  size="small"
                  fullWidth
                  {...field}
                  style={{ backgroundColor: "white" }}
                  placeholder="Enter dob"
                  value={Dob ? Dob : ""}
                  onChange={(e) => {
                    setValue("dob", e.target.value);
                    setDob(e.target.value);
                  }}
                  error={errors.dob}
                />
              )}
            />
            <p style={{ color: "red", fontSize: "14px" }}>
              {errors.dob?.message}
            </p>
          </Grid>
          <Grid item xs={4} style={{ paddingBottom: "0px" }}>
            <Controller
              name="gender"
              margin="dense"
              {...register("gender")}
              control={control}
              render={({ field }) => (
                <ReactSelect
                  style={{ marginTop: 0, marginBottom: 0 }}
                  {...field}
                  options={[
                    { value: "Male", label: "Male" },
                    { value: "Female", label: "Female" },
                    { value: "Other", label: "Other" },
                  ]}
                  value={{ label: getValues("gender") }}
                  onChange={(value) => setValue("gender", value.label)}
                  size="small"
                  error={errors.gender}
                />
              )}
            />
            <p style={{ color: "red", fontSize: "14px" }}>
              {errors.gender?.message}
            </p>
          </Grid>
          <Grid item xs={4}>
            <InputMask
              mask="999-99-9999"
              disabled={false}
              value={ssN}
              style={{ height: "30px" }}
              onChange={(e) => {
                setValue("ssn", e.target.value);
                setssn(e.target.value);
              }}
            >
              {() => (
                <TextField
                  id="outlined-basic"
                  fullWidth
                  size="small"
                  placeholder="Enter SSN"
                  style={{ backgroundColor: "white" }}
                />
              )}
            </InputMask>
          </Grid>
          <Grid item xs={4}>
            <Typography component="label" color="black">
              Contact Phone
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography component="label" color="black">
              Address
            </Typography>
            <label
              style={{ fontWeight: "bold", color: "red", fontSize: "15px" }}
            >
              *
            </label>
          </Grid>
          <Grid item xs={4}>
            <Typography component="label" color="black">
              Status
            </Typography>
            <label
              style={{ fontWeight: "bold", color: "red", fontSize: "15px" }}
            >
              *
            </label>
          </Grid>
          <Grid item xs={4}>
            <InputMask
              mask="+1 999-999-9999"
              disabled={false}
              value={cellPhone}
              style={{ height: "30px" }}
              onChange={(e) => {
                setValue("cellPhone", e.target.value);
                setcellPhone(e.target.value);
              }}
            >
              {() => (
                <TextField
                  id="outlined-basic"
                  style={{ backgroundColor: "white" }}
                  fullWidth
                  size="small"
                  placeholder="Enter Contact Phone"
                />
              )}
            </InputMask>
          </Grid>
          <Grid item xs={4}>
            <Controller
              name="address"
              {...register("address")}
              control={control}
              render={({ field }) => (
                <TextField
                  // isClearable
                  size="small"
                  style={{ backgroundColor: "white" }}
                  placeholder="Enter Address"
                  {...field}
                  fullWidth
                  error={errors.address}
                />
              )}
            />
            <p style={{ color: "red", fontSize: "14px" }}>
              {errors.address?.message}
            </p>
          </Grid>
          <Grid item xs={4}>
            <Controller
              name="status"
              margin="dense"
              {...register("status")}
              control={control}
              render={({ field }) => (
                <ReactSelect
                  style={{ marginTop: 0, marginBottom: 0 }}
                  {...field}
                  options={[
                    { value: "Active", label: "Active" },
                    { value: "InActive", label: "InActive" },
                    { value: "Discharge", label: "Discharge" },
                  ]}
                  value={{ label: getValues("status") }}
                  onChange={(value) => setValue("status", value.label)}
                  size="small"
                  error={errors.status}
                />
              )}
            />
            <p style={{ color: "red", fontSize: "14px" }}>
              {errors.status?.message}
            </p>
          </Grid>

          <Grid item xs={4}>
            <Typography component="label" color="black">
              City
            </Typography>
            <label
              style={{ fontWeight: "bold", color: "red", fontSize: "15px" }}
            >
              *
            </label>
          </Grid>
          <Grid item xs={4}>
            <Typography component="label" color="black">
              State
            </Typography>
            <label
              style={{ fontWeight: "bold", color: "red", fontSize: "15px" }}
            >
              *
            </label>
          </Grid>
          <Grid item xs={4}>
            <Typography component="label" color="black">
              Zip Code
            </Typography>
            <label
              style={{ fontWeight: "bold", color: "red", fontSize: "15px" }}
            >
              *
            </label>
          </Grid>

          <Grid item xs={4}>
            <Controller
              name="city"
              {...register("city")}
              control={control}
              render={({ field }) => (
                <TextField
                  // isClearable
                  size="small"
                  style={{ backgroundColor: "white" }}
                  placeholder="Please enter City"
                  {...field}
                  fullWidth
                  error={errors.city}
                />
              )}
            />
            <p style={{ color: "red", fontSize: "14px" }}>
              {errors.city?.message}
            </p>
          </Grid>
          <Grid item xs={4}>
            <Controller
              name="state"
              margin="dense"
              {...register("state")}
              control={control}
              render={({ field }) => (
                <ReactSelect
                  style={{ marginTop: 0, marginBottom: 0 }}
                  {...field}
                  options={[
                    { value: "AL", label: "ALABAMA" },
                    { value: "AK", label: "ALASKA" },
                    { value: "AS", label: "AMERICAN SAMOA" },
                    { value: "AZ", label: "ARIZONA" },
                    { value: "AR", label: "ARKANSAS" },
                    { value: "CA", label: "CALIFORNIA" },
                    { value: "CO", label: "COLORADO" },
                    { value: "CT", label: "CONNECTICUT" },
                    { value: "DE", label: "DELAWARE" },
                    { value: "DC", label: "DISTRICT OF COLUMBIA" },
                    { value: "FL", label: "FLORIDA" },
                    { value: "GA", label: "GEORGIA" },
                    { value: "GU", label: "GUAM" },
                    { value: "HI", label: "HAWAII" },
                    { value: "ID", label: "IDAHO" },
                    { value: "IL", label: "ILLINOIS" },
                    { value: "IN", label: "INDIANA" },
                    { value: "IA", label: "IOWA" },
                    { value: "KS", label: "KANSAS" },
                    { value: "KY", label: "KENTUCKY" },
                    { value: "LA", label: "LOUISIANA" },
                    { value: "ME", label: "MAINE" },
                    { value: "MD", label: "MARYLAND" },
                    { value: "MA", label: "MASSACHUSETTS" },
                    { value: "MI", label: "MICHIGAN" },
                    { value: "MN", label: "MINNESOTA" },
                    { value: "MS", label: "MISSISSIPPI" },
                    { value: "MO", label: "MISSOURI" },
                    { value: "MT", label: "MONTANA" },
                    { value: "NE", label: "NEBRASKA" },
                    { value: "NV", label: "NEVADA" },
                    { value: "NH", label: "NEW HAMPSHIRE" },
                    { value: "NJ", label: "NEW JERSEY" },
                    { value: "NM", label: "NEW MEXICO" },
                    { value: "NY", label: "NEW YORK" },
                    { value: "NC", label: "NORTH CAROLINA" },
                    { value: "ND", label: "NORTH DAKOTA" },
                    { value: "MP", label: "NORTHERN MARIANA IS" },
                    { value: "OH", label: "OHIO" },
                    { value: "OK", label: "OKLAHOMA" },
                    { value: "OR", label: "OREGON" },
                    { value: "PA", label: "PENNSYLVANIA" },
                    { value: "PR", label: "PUERTO RICO" },
                    { value: "PI", label: "RHODE ISLAND" },
                    { value: "SC", label: "SOUTH CAROLINA" },
                    { value: "SD", label: "SOUTH DAKOTA" },
                    { value: "TN", label: "TENNESSEE" },
                    { value: "TX", label: "TEXAS" },
                    { value: "UT", label: "UTAH" },
                    { value: "VT", label: "VERMONT" },
                    { value: "VA", label: "VIRGINIA" },
                    { value: "VI", label: "VIRGIN ISLANDS" },
                    { value: "WA", label: "WASHINGTON" },
                    { value: "WV", label: "WEST VIRGINIA" },
                    { value: "WI", label: "WISCONSIN" },
                    { value: "WY", label: "WYOMING" },
                  ]}
                  value={{ label: getValues("state") }}
                  onChange={(value) => setValue("state", value.label)}
                  size="small"
                  error={errors.state}
                />
              )}
            />
            <p style={{ color: "red", fontSize: "14px" }}>
              {errors.state?.message}
            </p>
          </Grid>
          <Grid item xs={4}>
            <Controller
              name="zipCode"
              {...register("zipCode")}
              control={control}
              render={({ field }) => (
                <TextField
                  size="small"
                  style={{ backgroundColor: "white" }}
                  placeholder="Please enter zipCode"
                  {...field}
                  fullWidth
                  error={errors.zipCode}
                />
              )}
            />
            <p style={{ color: "red", fontSize: "14px" }}>
              {errors.zipCode?.message}
            </p>
          </Grid>
          
         <Grid item md={4.5} sm={4.5} xs={4.5}>
              <Typography component="label" color="black">
                Primary Referring Physician
              </Typography>

              <Controller
                name="primaryReferringPhysician"
                control={control}
                render={({ field }) => (
                  <ReactSelect
                    {...field}
                    options={referringPhysicianName}
                    value={referringPhysicianName.find(
                      option => option.value === field.value?.referringPhysicianId
                    ) || null}
                    onChange={(selected) => {
                      field.onChange({
                        id: field.value?.id || 0,
                        referringPhysicianId: selected?.value || null,
                        patientId: patientId,
                        inactive: false
                      });
                    }}
                  />
                )}
              />
          </Grid>

          <Grid item md={4.5} sm={4.5} xs={4.5}>
            <Typography component="label" color="black">
              Secondary Referring Physician
            </Typography>

            <Controller
              name="secondaryReferringPhysician"
              control={control}
              render={({ field }) => (
                <ReactSelect
                  {...field}
                  options={referringPhysicianName}
                  value={referringPhysicianName.find(
                    option => option.value === field.value?.referringPhysicianId
                  ) || null}
                  onChange={(selected) => {
                    field.onChange({
                      id: field.value?.id || 0,
                      referringPhysicianId: selected?.value || null,
                      patientId: patientId,
                      inactive: false
                    });
                  }}
                />
              )}
            />
          </Grid>
           <Grid
              item
             md={3} sm={3} xs={3}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center", 
                justifyContent: "center",
                mt:1
              }}
            >
              <Button
                variant="contained"
                size="small"
                onClick={handleOpenNewProvider}
                sx={{ 
                  width: "auto",
                  minWidth: 180,
                  maxWidth: "100%",
                   fontSize: "0.7rem", 
                }} 
              >
                Add New Provider to Dropdown List
              </Button>

              <Typography
                variant="caption"
                sx={{
                  mt: 0.5,
                  color: "text.secondary",
                  fontStyle: "italic",
                  textAlign: "center", 
                }}
              >
                If not available on dropdown.
              </Typography>
            </Grid>
          <Grid item xs={12}>
            <Typography component="label" color="black">
              Comments
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="comments"
              {...register("comments")}
              control={control}
              render={({ field }) => (
                <TextareaAutosize
                  aria-label="minimum height"
                  minRows={1}
                  placeholder="Enter comments"
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    border: "2px solid #black",
                    height: "100px", // set a fixed height here
                    overflow: "scroll",
                  }}
                  {...field}
                  fullWidth
                />
              )}
            />
          </Grid>

        </Grid>
        <Grid
          spacing={1}
          alignContent="left"
          justifyContent="left"
          style={{
            width: "100% !important",
            marginLeft: "0px !important",
          }}
        >
          <Accordion
            style={{
              width: "100%",
              marginBottom: "10px",
              border: "1px solid #347310",
              borderRadius: "20px",
              marginTop: "10px",
              marginLeft: "5px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Box
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <MedicalServicesIcon
                    style={{ color: "#347310", fontSize: "20px" }}
                  />
                  <Typography
                    style={{
                      fontWeight: "600",
                      fontSize: "16px",
                      color: "#2c3e50",
                    }}
                  >
                    Insurance
                  </Typography>
                </Box>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <TabContext value={tabValueIns}>
                  <Box
                    sx={{
                      borderBottom: 1,
                      borderColor: "divider",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px",
                    }}
                  >
                    <TabList
                      onChange={handleChangeInsurances}
                      aria-label="lab API tabs example"
                    >
                      <Tab
                        value={0}
                        icon={<PermIdentity />}
                        label="PRIMARY INSURANCE"
                      />
                      <Tab
                        value={1}
                        icon={<AssignmentTurnedInIcon />}
                        label="SECONDARY INSURANCE"
                      />
                      <Tab
                        value={2}
                        icon={<DataThresholdingIcon />}
                        label="TERTIARY INSURANCE"
                      />
                    </TabList>

                    {patientId > 0 && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                        }}
                      >
                        {rights?.Eligiblity_Check && (
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            sx={{
                              backgroundColor: "#A574FD",
                              color: "white",
                              width: "180px",
                              marginBottom: 1,
                              "&:hover": {
                                backgroundColor: "#8A5CE6",
                              },
                            }}
                            onClick={handleOpenEligiblity}
                          >
                            Check Eligibility
                          </Button>
                        )}
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          sx={{ width: "180px" }}
                          onClick={handleOpenNewInsurance}
                        >
                          Add New Insurance
                        </Button>

                        <span
                          style={{
                            marginTop: "4px",
                            fontSize: "12px",
                            color: "#6c757d",
                            fontStyle: "italic",
                            textAlign: "right",
                          }}
                        >
                          If not available on dropdown.
                        </span>
                      </div>
                    )}
                  </Box>
                  <TabPanel value={0}>
                    {submitting && <div>Saving Form...</div>}
                    <Grid
                      container
                      spacing={1}
                      alignContent="center"
                      justifyContent="center"
                    >
                      <Grid item xs={12}>
                        <Grid container spacing={1}>
                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Typography style={{ fontSize: "14px" }}>
                              Insurance{" "}
                              <b style={{ color: "red", fontSize: "15px" }}>
                                *
                              </b>
                            </Typography>
                          </Grid>

                          {UserType === "Front Office" ||
                          UserType === "Front Office Admin" ? (
                            ""
                          ) : (
                            <Grid item xs={6} sm={3} xl={3}>
                              <Typography style={{ fontSize: "14px" }}>
                                Payer{" "}
                              <b style={{ color: "red", fontSize: "15px" }}>
                                *
                              </b>
                              </Typography>
                            </Grid>
                          )}
                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Typography style={{ fontSize: "14px" }}>
                              Group Id
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Typography style={{ fontSize: "14px" }}>
                              Member Id{" "}
                              <b style={{ color: "red", fontSize: "15px" }}>
                                *
                              </b>
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Controller
                              name="Primary Insurance"
                              {...register("priIns.planName")}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  type="input"
                                  fullWidth
                                  size="small"
                                  placeholder="Primary Insurance"
                                  onKeyUp={(ev) => {
                                    if (
                                      ev.target.value !== "" &&
                                      ev.target.value !== null
                                    ) {
                                      onchangeinsurce(ev.target.value);
                                    } else {
                                      setinsuranceNames([]);
                                      setOpenInsurances(false);
                                    }
                                  }}
                                  error={!!errors.priIns?.planName}
                                  helperText={errors.priIns?.planName?.message}
                                />
                              )}
                            />
                            {openInsurances ? (
                              <div
                                className="col-xs-3"
                                style={{
                                  padding: "14px 16px",
                                  fontSize: "0.875rem",
                                  color: "#67748e",
                                  borderRadius: "5px",
                                  background: "white",
                                  textAlign: "justify",
                                  textJustify: "inter-word",
                                  position: "absolute",
                                  zIndex: "99",
                                  width: "25%",
                                  border: "1px solid #6cb5f9",
                                }}
                              >
                                {insuranceNames.map((s, index) => (
                                  <p
                                    style={zipCodeListStyle}
                                    onClick={(ev) => {
                                      console.log(
                                        "Selected: ",
                                        zipCodeList[index],
                                      );
                                      setValue(
                                        "priIns.insuranceId",
                                        insuranceNames[index].id,
                                      );
                                      setValue(
                                        "priIns.payerId",
                                        insuranceNames[index].payerid,
                                      );
                                      setValue(
                                        "priIns.planName",
                                        insuranceNames[index].name,
                                      );
                                      setValue(
                                        "priIns.insuranceType",
                                        insuranceNames[index].insurnaceType,
                                      );
                                      setOpenInsurances(false);
                                      setinsuranceNames([]);
                                    }}
                                    onBlur={(ev) => {
                                      setinsuranceNames([]);
                                      setOpenInsurances(false);
                                    }}
                                    onChange={(ev) => {
                                      setinsuranceNames([]);
                                      setOpenInsurances(false);
                                    }}
                                  >
                                    {s.name}
                                  </p>
                                ))}
                              </div>
                            ) : (
                              ""
                            )}
                          </Grid>

                          {false ? (
                            <TextField
                              type="hidden"
                              placeholder="Insurance"
                              {...register("priIns.insuranceId")}
                              error={errors.insuranceId}
                              label="Insurance"
                              fullWidth
                              margin="dense"
                            />
                          ) : null}
                          {UserType === "Front Office" ||
                          UserType === "Front Office Admin" ? (
                            " "
                          ) : (
                            <Grid item xs={6} sm={3} xl={3}>
                              <Controller
                                name="payerId"
                                {...register("priIns.payerId")}
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    size="small"
                                    type="input"
                                    placeholder="payerId"
                                    {...field}
                                    fullWidth
                          //                 error={!!insuranceErrors["priIns.payerId"]}
                          //  helperText={insuranceErrors["priIns.payerId"]}
                                  />
                                )}
                              />
                            </Grid>
                          )}

                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Controller
                              name="payerId"
                              {...register("priIns.groupId")}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  type="input"
                                  placeholder="groupId"
                                  {...field}
                                  fullWidth
                                  error={!!errors.priIns?.groupId}
                                  helperText={errors.priIns?.groupId?.message}
                                />
                              )}
                            />
                          </Grid>

                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Controller
                              name="memberId"
                              {...register("priIns.memberId")}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  type="text"
                                  placeholder="Enter Member Id"
                                  {...field}
                                  fullWidth
      //                             error={!!insuranceErrors["priIns.memberId"]}
      // helperText={insuranceErrors["priIns.memberId"]}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={6} sm={3} xl={3}>
                            <Typography style={{ fontSize: "14px" }}>
                              Relation{" "}
                              <b style={{ color: "red", fontSize: "15px" }}>
                                *
                              </b>
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3} xl={3}>
                            <Typography style={{ fontSize: "14px" }}>
                              {Self ? "First Name" : "Subscriber First Name"}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3} xl={3}>
                            <Typography style={{ fontSize: "14px" }}>
                              {Self ? "Last Name" : "Subscriber Last Name"}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3} xl={3}>
                            <Typography style={{ fontSize: "14px" }}>
                              Type
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3} xl={3}>
                            <Controller
                              name="priIns.subsRelation"
                              margin="dense"
                              {...register("priIns.subsRelation")}
                              control={control}
                              render={({ field }) => (
                                <ReactSelect
                                  style={{ marginTop: 0, marginBottom: 0 }}
                                  {...field}
                                  options={[
                                    { value: "Self", label: "Self" },
                                    { value: "Spouse", label: "Spouse" },
                                    { value: "Mother", label: "Mother" },
                                    { value: "Father", label: "Father" },
                                    { value: "Other", label: "Other" },
                                  ]}
                                  value={{
                                    label: getValues("priIns.subsRelation"),
                                  }}
                                  onChange={(value) => {
                                    setValue(
                                      "priIns.subsRelation",
                                      value.label,
                                    );
                                    setSelf(value.value === "Self");
                                  }}
                                  size="small"
                                  error={!!errors.priIns?.subsRelation}
                                />
                              )}
                            />
                            <p style={{ color: "red", fontSize: "14px" }}>
                              {errors.priIns?.subsRelation?.message}
                            </p>
                          </Grid>
                          {watch("priIns.subsRelation") == "Self"  ? (
                            <>
                              <Grid item xs={6} sm={3} xl={3}>
                                <Controller
                                  name="priIns.subsFirstName"
                                  {...register("priIns.subsFirtName")}
                                  control={control}
                                  render={({ field }) => (
                                    <TextField
                                      size="small"
                                      fullWidth
                                      {...field}
                                      value={PfirstName ? PfirstName : ""}
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={6} sm={3} xl={3}>
                                <Controller
                                  name="priIns.subsLastName"
                                  {...register("priIns.subsLastName")}
                                  control={control}
                                  render={({ field }) => (
                                    <TextField
                                      size="small"
                                      fullWidth
                                      {...field}
                                      value={PLastName ? PLastName : ""}
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  )}
                                />
                              </Grid>
                            </>
                          ) : (
                            <>
                              <Grid item xs={6} sm={3} xl={3}>
                                <Controller
                                  name="priIns.subsFirstName"
                                  {...register("priIns.subsFirtName")}
                                  control={control}
                                  render={({ field }) => (
                                    <TextField
                                      size="small"
                                      type="input"
                                      placeholder="Enter Subscriber First Name"
                                      {...field}
                                      fullWidth
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={6} sm={3} xl={3}>
                                <Controller
                                  name="priIns.subsLastName"
                                  {...register("priIns.subsLastName")}
                                  control={control}
                                  render={({ field }) => (
                                    <TextField
                                      size="small"
                                      type="input"
                                      placeholder="Enter Subscriber Last Name"
                                      {...field}
                                      fullWidth
                                    />
                                  )}
                                />
                              </Grid>
                            </>
                          )}

                          <Grid item xs={6} sm={3} xl={3}>
                            <Controller
                              name="priIns.type"
                              {...register("priIns.type")}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  type="input"
                                  {...field}
                                  fullWidth
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </TabPanel>
                  <TabPanel value={1}>
                    {submitting && <div>Saving Form...</div>}
                    <Grid
                      container
                      spacing={1}
                      alignContent="center"
                      justifyContent="center"
                    >
                      <Grid item xs={12}>
                        <Grid container spacing={1}>
                          <Grid
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Typography style={{ fontSize: "14px" }}>
                              Insurance
                            </Typography>
                          </Grid>
                          {UserType === "Front Office" ||
                          UserType === "Front Office Admin" ? (
                            ""
                          ) : (
                            <Grid item xs={6} sm={3} xl={3}>
                              <Typography style={{ fontSize: "14px" }}>
                                   Payer{" "}
                              <b style={{ color: "red", fontSize: "15px" }}>
                                *
                              </b>
                              </Typography>
                            </Grid>
                          )}
                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Typography style={{ fontSize: "14px" }}>
                              Group Id
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Typography style={{ fontSize: "14px" }}>
                              Member Id
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Controller
                              name="secIns.planName"
                              {...register("secIns.planName")}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  type="input"
                                  fullWidth
                                  size="small"
                                  placeholder="Secondary Insurance"
                                  onKeyUp={(ev) => {
                                    if (
                                      ev.target.value !== "" &&
                                      ev.target.value !== null
                                    ) {
                                      onchangeinsurce(ev.target.value);
                                    } else {
                                      setinsuranceNames([]);
                                      setOpenInsurances(false);
                                    }
                                  }}
                                  error={!!errors.secIns?.planName}
                                  helperText={errors.secIns?.planName?.message}
                                />
                              )}
                            />

                            {openInsurances ? (
                              <div
                                className="col-xs-3"
                                style={{
                                  padding: "14px 16px",
                                  fontSize: "0.875rem",
                                  color: "#67748e",
                                  borderRadius: "5px",
                                  background: "white",
                                  textAlign: "justify",
                                  textJustify: "inter-word",
                                  position: "absolute",
                                  zIndex: "99",
                                  width: "25%",
                                  border: "1px solid #6cb5f9",
                                }}
                              >
                                {insuranceNames.map((s, index) => (
                                  <p
                                    style={zipCodeListStyle}
                                    onClick={(ev) => {
                                      console.log(
                                        "Selected: ",
                                        zipCodeList[index],
                                      );
                                      setValue(
                                        "secIns.insuranceId",
                                        insuranceNames[index].id,
                                      );
                                      setValue(
                                        "secIns.payerId",
                                        insuranceNames[index].payerid,
                                      );
                                      setValue(
                                        "secIns.planName",
                                        insuranceNames[index].name,
                                      );
                                      setValue(
                                        "secIns.insuranceType",
                                        insuranceNames[index].insurnaceType,
                                      );
                                      setOpenInsurances(false);
                                      setinsuranceNames([]);
                                    }}
                                    onBlur={(ev) => {
                                      setinsuranceNames([]);
                                      setOpenInsurances(false);
                                    }}
                                    onChange={(ev) => {
                                      setinsuranceNames([]);
                                      setOpenInsurances(false);
                                    }}
                                  >
                                    {s.name}
                                  </p>
                                ))}
                              </div>
                            ) : (
                              ""
                            )}
                          </Grid>

                          {false ? (
                            <TextField
                              type="hidden"
                              placeholder="Insurance"
                              {...register("secIns.insuranceId")}
                              error={errors.insuranceId}
                              label="Insurance"
                              fullWidth
                              margin="dense"
                            />
                          ) : null}
                          {UserType === "Front Office" ||
                          UserType === "Front Office Admin" ? (
                            ""
                          ) : (
                            <Grid item xs={6} sm={3} xl={3}>
                              <Controller
                                name="secIns.payerId"
                                {...register("secIns.payerId")}
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    size="small"
                                    type="input"
                                    placeholder="payerId"
                                    {...field}
                                    fullWidth
                                    //   error={!!insuranceErrors["secIns.payerId"]}
                                    //  helperText={insuranceErrors["secIns.payerId"]}
                                  />
                                )}
                              />
                            </Grid>
                          )}
                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Controller
                              name="secIns.groupId"
                              {...register("secIns.groupId")}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  type="input"
                                  placeholder="groupId"
                                  {...field}
                                  fullWidth
                                  error={!!errors.secIns?.groupId}
                                  helperText={errors.secIns?.groupId?.message}
                                />
                              )}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Controller
                              name="secIns.memberId"
                              {...register("secIns.memberId")}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  type="text"
                                  placeholder="Enter Member Id"
                                  {...field}
                                  fullWidth
                                    //  error={!!insuranceErrors["secIns.memberId"]}
                                    //       helperText={insuranceErrors["secIns.memberId"]}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={6} sm={3} xl={3}>
                            <Typography style={{ fontSize: "14px" }}>
                              Relation
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3} xl={3}>
                            <Typography style={{ fontSize: "14px" }}>
                              {Selected
                                ? "First Name"
                                : "Subscriber First Name"}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3} xl={3}>
                            <Typography style={{ fontSize: "14px" }}>
                              {Selected ? "Last Name" : "Subscriber Last Name"}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3} xl={3}>
                            <Typography style={{ fontSize: "14px" }}>
                              Type
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3} xl={3}>
                            <Controller
                              name="secIns.subsRelation"
                              margin="dense"
                              {...register("secIns.subsRelation")}
                              control={control}
                              render={({ field }) => (
                                <ReactSelect
                                  style={{ marginTop: 0, marginBottom: 0 }}
                                  {...field}
                                  options={[
                                    { value: "Self", label: "Self" },
                                    { value: "Spouse", label: "Spouse" },
                                    { value: "Mother", label: "Mother" },
                                    { value: "Father", label: "Father" },
                                    { value: "Other", label: "Other" },
                                  ]}
                                  value={{
                                    label: getValues("secIns.subsRelation"),
                                  }}
                                  onChange={(value) => {
                                    setValue(
                                      "secIns.subsRelation",
                                      value.label,
                                    );
                                    setSelected(value.value === "Self");
                                  }}
                                  size="small"
                                />
                              )}
                            />
                          </Grid>

                          {watch("secIns.subsRelation") == "Self"  ? (
                            <>
                              <Grid item xs={6} sm={3} xl={3}>
                                <Controller
                                  name="secIns.subsFirtName"
                                  {...register("secIns.subsFirtName")}
                                  control={control}
                                  render={({ field }) => (
                                    <TextField
                                      size="small"
                                      fullWidth
                                      {...field}
                                      value={PfirstName ? PfirstName : ""}
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={6} sm={3} xl={3}>
                                <Controller
                                  name="secIns.subsLastName"
                                  {...register("secIns.subsLastName")}
                                  control={control}
                                  render={({ field }) => (
                                    <TextField
                                      size="small"
                                      fullWidth
                                      {...field}
                                      value={PLastName ? PLastName : ""}
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  )}
                                />
                              </Grid>
                            </>
                          ) : (
                            <>
                              <Grid item xs={6} sm={3} xl={3}>
                                <Controller
                                  name="secIns.subsFirtName"
                                  {...register("secIns.subsFirtName")}
                                  control={control}
                                  render={({ field }) => (
                                    <TextField
                                      size="small"
                                      type="input"
                                      placeholder="Enter Subscriber First Name"
                                      {...field}
                                      fullWidth
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={6} sm={3} xl={3}>
                                <Controller
                                  name="secIns.subsLastName"
                                  {...register("secIns.subsLastName")}
                                  control={control}
                                  render={({ field }) => (
                                    <TextField
                                      size="small"
                                      type="input"
                                      placeholder="Enter Subscriber Last Name"
                                      {...field}
                                      fullWidth
                                    />
                                  )}
                                />
                              </Grid>
                            </>
                          )}
                          <Grid item xs={6} sm={3} xl={3}>
                            <Controller
                              name="secIns.type"
                              {...register("secIns.type")}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  type="input"
                                  {...field}
                                  fullWidth
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </TabPanel>

                  <TabPanel value={2}>
                    {submitting && <div>Saving Form...</div>}
                    <Grid
                      container
                      spacing={1}
                      alignContent="center"
                      justifyContent="center"
                    >
                      <Grid item xs={12}>
                        <Grid container spacing={1}>
                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Typography style={{ fontSize: "14px" }}>
                              Insurance
                            </Typography>
                          </Grid>
                          {UserType === "Front Office" ||
                          UserType === "Front Office Admin" ? (
                            ""
                          ) : (
                            <Grid item xs={6} sm={3} xl={3}>
                              <Typography style={{ fontSize: "14px" }}>
                                   Payer{" "}
                              <b style={{ color: "red", fontSize: "15px" }}>
                                *
                              </b>
                              </Typography>
                            </Grid>
                          )}
                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Typography style={{ fontSize: "14px" }}>
                              Group Id
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Typography style={{ fontSize: "14px" }}>
                              Member Id
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Controller
                              name="triIns.planName"
                              {...register("triIns.planName")}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  type="input"
                                  fullWidth
                                  size="small"
                                  placeholder="Tertiary Insurance"
                                  onKeyUp={(ev) => {
                                    if (
                                      ev.target.value !== "" &&
                                      ev.target.value !== null
                                    ) {
                                      onchangeinsurce(ev.target.value);
                                    } else {
                                      setinsuranceNames([]);
                                      setOpenInsurances(false);
                                    }
                                  }}
                                  error={!!errors.secIns?.planName}
                                  helperText={errors.secIns?.planName?.message}
                                />
                              )}
                            />

                            {openInsurances ? (
                              <div
                                className="col-xs-3"
                                style={{
                                  padding: "14px 16px",
                                  fontSize: "0.875rem",
                                  color: "#67748e",
                                  borderRadius: "5px",
                                  background: "white",
                                  textAlign: "justify",
                                  textJustify: "inter-word",
                                  position: "absolute",
                                  zIndex: "99",
                                  width: "25%",
                                  border: "1px solid #6cb5f9",
                                }}
                              >
                                {insuranceNames.map((s, index) => (
                                  <p
                                    style={zipCodeListStyle}
                                    onClick={(ev) => {
                                      console.log(
                                        "Selected: ",
                                        zipCodeList[index],
                                      );
                                      setValue(
                                        "triIns.insuranceId",
                                        insuranceNames[index].id,
                                      );
                                      setValue(
                                        "triIns.payerId",
                                        insuranceNames[index].payerid,
                                      );
                                      setValue(
                                        "triIns.planName",
                                        insuranceNames[index].name,
                                      );
                                      setValue(
                                        "triIns.insuranceType",
                                        insuranceNames[index].insurnaceType,
                                      );
                                      setOpenInsurances(false);
                                      setinsuranceNames([]);
                                    }}
                                    onBlur={(ev) => {
                                      setinsuranceNames([]);
                                      setOpenInsurances(false);
                                    }}
                                    onChange={(ev) => {
                                      setinsuranceNames([]);
                                      setOpenInsurances(false);
                                    }}
                                  >
                                    {s.name}
                                  </p>
                                ))}
                              </div>
                            ) : (
                              ""
                            )}
                          </Grid>

                          {false ? (
                            <TextField
                              type="hidden"
                              placeholder="Insurance"
                              {...register("triIns.insuranceId")}
                              error={errors.insuranceId}
                              label="Insurance"
                              fullWidth
                              margin="dense"
                            />
                          ) : null}
                          {UserType === "Front Office" ||
                          UserType === "Front Office Admin" ? (
                            ""
                          ) : (
                            <Grid item xs={6} sm={3} xl={3}>
                              <Controller
                                name="triIns.payerId"
                                {...register("triIns.payerId")}
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    size="small"
                                    type="input"
                                    placeholder="payerId"
                                    {...field}
                                    fullWidth
                                //          error={!!insuranceErrors["triIns.payerId"]}
                                //  helperText={insuranceErrors["triIns.payerId"]}
                                  />
                                )}
                              />
                            </Grid>
                          )}
                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Controller
                              name="triIns.groupId"
                              {...register("triIns.groupId")}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  type="input"
                                  placeholder="groupId"
                                  {...field}
                                  fullWidth
                                  error={!!errors.secIns?.groupId}
                                  helperText={errors.secIns?.groupId?.message}
                                />
                              )}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                            xl={
                              UserType === "Front Office" ||
                              UserType === "Front Office Admin"
                                ? 4
                                : 3
                            }
                          >
                            <Controller
                              name="triIns.memberId"
                              {...register("triIns.memberId")}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  type="text"
                                  placeholder="Enter Member Id"
                                  {...field}
                                  fullWidth
      //                      error={!!insuranceErrors["triIns.memberId"]}
      // helperText={insuranceErrors["triIns.memberId"]}
                                />
                              )}
                            />
                          </Grid>

                          <Grid item xs={6} sm={3} xl={3}>
                            <Typography style={{ fontSize: "14px" }}>
                              Relation
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3} xl={3}>
                            <Typography style={{ fontSize: "14px" }}>
                              {Selected
                                ? "First Name"
                                : "Subscriber First Name"}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3} xl={3}>
                            <Typography style={{ fontSize: "14px" }}>
                              {Selected ? "Last Name" : "Subscriber Last Name"}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3} xl={3}>
                            <Typography style={{ fontSize: "14px" }}>
                              Type
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={3} xl={3}>
                            <Controller
                              name="triIns.subsRelation"
                              margin="dense"
                              {...register("triIns.subsRelation")}
                              control={control}
                              render={({ field }) => (
                                <ReactSelect
                                  style={{ marginTop: 0, marginBottom: 0 }}
                                  {...field}
                                  options={[
                                    { value: "Self", label: "Self" },
                                    { value: "Spouse", label: "Spouse" },
                                    { value: "Mother", label: "Mother" },
                                    { value: "Father", label: "Father" },
                                    { value: "Other", label: "Other" },
                                  ]}
                                  value={{
                                    label: getValues("triIns.subsRelation"),
                                  }}
                                  onChange={(value) => {
                                    setValue(
                                      "triIns.subsRelation",
                                      value.label,
                                    );
                                    setSelected(value.value === "Self");
                                  }}
                                  size="small"
                                />
                              )}
                            />
                          </Grid>

                          {watch("triIns.subsRelation") == "Self"  ? (
                            <>
                              <Grid item xs={6} sm={3} xl={3}>
                                <Controller
                                  name="triIns.subsFirtName"
                                  {...register("triIns.subsFirtName")}
                                  control={control}
                                  render={({ field }) => (
                                    <TextField
                                      size="small"
                                      fullWidth
                                      {...field}
                                      value={PfirstName ? PfirstName : ""}
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={6} sm={3} xl={3}>
                                <Controller
                                  name="triIns.subsLastName"
                                  {...register("triIns.subsLastName")}
                                  control={control}
                                  render={({ field }) => (
                                    <TextField
                                      size="small"
                                      fullWidth
                                      {...field}
                                      value={PLastName ? PLastName : ""}
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  )}
                                />
                              </Grid>
                            </>
                          ) : (
                            <>
                              <Grid item xs={6} sm={3} xl={3}>
                                <Controller
                                  name="triIns.subsFirtName"
                                  {...register("triIns.subsFirtName")}
                                  control={control}
                                  render={({ field }) => (
                                    <TextField
                                      size="small"
                                      type="input"
                                      placeholder="Enter Subscriber First Name"
                                      {...field}
                                      fullWidth
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={6} sm={3} xl={3}>
                                <Controller
                                  name="triIns.subsLastName"
                                  {...register("triIns.subsLastName")}
                                  control={control}
                                  render={({ field }) => (
                                    <TextField
                                      size="small"
                                      type="input"
                                      placeholder="Enter Subscriber Last Name"
                                      {...field}
                                      fullWidth
                                    />
                                  )}
                                />
                              </Grid>
                            </>
                          )}
                          <Grid item xs={6} sm={3} xl={3}>
                            <Controller
                              name="triIns.type"
                              {...register("triIns.type")}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  type="input"
                                  {...field}
                                  fullWidth
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </TabPanel>
                </TabContext>
              </div>
            </AccordionDetails>
          </Accordion>
          {/*Eligibility */}
          {rights?.Eligiblity_Check && (
            <Accordion
              style={{
                width: "100%",
                marginBottom: "10px",
                border: "1px solid #347310",
                borderRadius: "20px",
                marginTop: "10px",
                marginLeft: "5px",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                {/* <Box
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                > */}
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <CheckCircleIcon
                    style={{ color: "#347310", fontSize: "20px" }}
                  />
                  <Typography
                    style={{
                      fontWeight: "600",
                      fontSize: "16px",
                      color: "#2c3e50",
                    }}
                  >
                    Eligibility
                  </Typography>
                </Box>
                {/* </Box> */}
              </AccordionSummary>

              <AccordionDetails
                style={{
                  padding: "0",
                }}
              >
                <Box
                  mb={3}
                  mt={2}
                  sx={{
                    padding: "10px",
                    maxHeight: "300px",
                    overflowY: "auto",
                  }}
                >
                  {/* ================= ELIGIBILITY DETAILS ================= */}
                  {detailLoading ? (
                    <Box textAlign="center" p={2}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    eligibilityDetail && (
                      <Paper
                        elevation={3}
                        sx={{
                          mb: 2,
                          p: 2,
                          borderRadius: "14px",
                          background: "#f9fafb",
                        }}
                      >
                        <Typography fontWeight={600} mb={1}>
                          Eligibility Details
                        </Typography>

                        <Grid container spacing={1}>
                          <Grid item xs={4}>
                            <b>Name:</b> {eligibilityDetail.ins_name_f}{" "}
                            {eligibilityDetail.ins_name_l}
                          </Grid>

                          <Grid item xs={4}>
                            <b>DOB:</b> {eligibilityDetail.eligibility_dob}
                          </Grid>

                          <Grid item xs={4}>
                            <b>Eligibility Date:</b>{" "}
                            {eligibilityDetail.eligibility_date}
                          </Grid>

                          <Grid item xs={4}>
                            <b>Gender:</b> {eligibilityDetail.ins_sex}
                          </Grid>

                          <Grid item xs={4}>
                            <b>Insurance #:</b> {eligibilityDetail.ins_number}
                          </Grid>

                          <Grid item xs={4}>
                            <b>Elig Id:</b> {eligibilityDetail.eligid}
                          </Grid>

                          <Grid item xs={4}>
                            <b>Zip:</b> {eligibilityDetail.ins_zip}
                          </Grid>

                          <Grid item xs={12}>
                            <b>Address:</b> {eligibilityDetail.ins_addr_1},{" "}
                            {eligibilityDetail.ins_city}
                          </Grid>
                        </Grid>

                        <Box>
                          {/* ================= Deductibles ================= */}
                          <Accordion
                            sx={{
                              borderRadius: "12px",
                              mt: 1,
                              backgroundColor: "#eef2ff",
                            }}
                          >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <Typography fontSize="0.9rem" fontWeight={600}>
                                Deductibles
                              </Typography>
                            </AccordionSummary>

                            <AccordionDetails sx={{ p: 1 }}>
                              {deductibleBenefits.length === 0 ? (
                                <Typography fontSize="0.85rem">
                                  No Deductibles Found
                                </Typography>
                              ) : (
                                // <Box>
                                //   {deductibleBenefits.map((item, index) => (
                                //     <Paper
                                //       key={index}
                                //       elevation={1}
                                //       sx={{
                                //         mb: 0.75,
                                //         p: 1,
                                //         borderRadius: "10px",
                                //         backgroundColor: "#fff",
                                //       }}
                                //     >
                                //       <Grid container spacing={0.5}>
                                //         {/* Colored Label for Deductible Type */}
                                //         <Grid item xs={12}>
                                //           <Typography
                                //             fontSize="0.8rem"
                                //             fontWeight={600}
                                //             sx={{
                                //               color: getDeductibleColor(item),
                                //               backgroundColor: "#f3f4f6",
                                //               px: 0.75,
                                //               py: 0.25,
                                //               borderRadius: "6px",
                                //               display: "inline-block",
                                //               mb: 0.5,
                                //             }}
                                //           >
                                //             {getDeductibleType(item)}{" "}
                                //             {item.benefit_coverage_description?.toLowerCase().includes("out of pocket")
                                //               ? "(OOP Max)"
                                //               : "Deductible"}
                                //           </Typography>
                                //         </Grid>

                                //         {/* Network */}
                                //         <Grid item xs={5}>
                                //           <Typography fontSize="0.8rem" fontWeight={600}>
                                //             Network
                                //           </Typography>
                                //           <Typography fontSize="0.8rem">
                                //             {getNetworkLabel(item.inplan_network)}
                                //           </Typography>
                                //         </Grid>

                                //         {/* Amount / Percent by Period */}
                                //         <Grid item xs={7}>
                                //           <Typography fontSize="0.8rem" fontWeight={600}>
                                //             Amount / Percent
                                //           </Typography>
                                //           <Typography fontSize="0.8rem">
                                //             {Object.entries(item.periods || {}).map(([period, val]) => (
                                //               <span key={period}>
                                //                 {period}: ${val.amount} {val.percent ? `(${val.percent}%)` : ""} <br />
                                //               </span>
                                //             ))}
                                //           </Typography>
                                //         </Grid>

                                //         {/* Service */}
                                //         {item.benefit_description && (
                                //           <Grid item xs={12}>
                                //             <Typography fontSize="0.8rem" fontWeight={600}>
                                //               Service
                                //             </Typography>
                                //             <Typography fontSize="0.8rem">
                                //               {item.benefit_description}
                                //             </Typography>
                                //           </Grid>
                                //         )}

                                //         {/* Notes */}
                                //         {item.benefit_notes && (
                                //           <Grid item xs={12}>
                                //             <Typography fontSize="0.8rem" fontWeight={600}>
                                //               Notes
                                //             </Typography>
                                //             <Typography fontSize="0.8rem">{item.benefit_notes}</Typography>
                                //           </Grid>
                                //         )}
                                //       </Grid>
                                //     </Paper>
                                //   ))}
                                // </Box>
                                <>
                                  <Accordion
                                    sx={{
                                      borderRadius: "12px",
                                      mt: 1,
                                      backgroundColor: "#FEF3C7",
                                    }}
                                  >
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                    >
                                      <Typography
                                        fontSize="0.9rem"
                                        fontWeight={600}
                                      >
                                        Individual Deductibles
                                      </Typography>
                                    </AccordionSummary>

                                    <AccordionDetails sx={{ p: 1 }}>
                                      {individualDeductibles.length === 0 ? (
                                        <Typography fontSize="0.85rem">
                                          No Deductibles Found
                                        </Typography>
                                      ) : (
                                        <Box>
                                          {individualDeductibles.map(
                                            (item, index) => (
                                              <Paper
                                                key={index}
                                                elevation={1}
                                                sx={{
                                                  mb: 0.75,
                                                  p: 1,
                                                  borderRadius: "10px",
                                                  backgroundColor: "#fff",
                                                }}
                                              >
                                                <Grid container spacing={0.5}>
                                                  {/* Colored Label for Deductible Type */}
                                                  <Grid item xs={12}>
                                                    <Typography
                                                      fontSize="0.8rem"
                                                      fontWeight={600}
                                                      sx={{
                                                        color:
                                                          getDeductibleColor(
                                                            item,
                                                          ),
                                                        backgroundColor:
                                                          "#f3f4f6",
                                                        px: 0.75,
                                                        py: 0.25,
                                                        borderRadius: "6px",
                                                        display: "inline-block",
                                                        mb: 0.5,
                                                      }}
                                                    >
                                                      {getDeductibleType(item)}{" "}
                                                      {item.benefit_coverage_description
                                                        ?.toLowerCase()
                                                        .includes(
                                                          "out of pocket",
                                                        )
                                                        ? "(OOP Max)"
                                                        : "Deductible"}
                                                    </Typography>
                                                  </Grid>

                                                  {/* Network */}
                                                  <Grid item xs={5}>
                                                    <Typography
                                                      fontSize="0.8rem"
                                                      fontWeight={600}
                                                    >
                                                      Network
                                                    </Typography>
                                                    <Typography fontSize="0.8rem">
                                                      {getNetworkLabel(
                                                        item.inplan_network,
                                                      )}
                                                    </Typography>
                                                  </Grid>

                                                  {/* Amount / Percent by Period */}
                                                  <Grid item xs={7}>
                                                    <Typography
                                                      fontSize="0.8rem"
                                                      fontWeight={600}
                                                    >
                                                      Amount / Percent
                                                    </Typography>
                                                    <Typography fontSize="0.8rem">
                                                      {Object.entries(
                                                        item.periods || {},
                                                      ).map(([period, val]) => (
                                                        <span key={period}>
                                                          {period}: $
                                                          {val.amount}{" "}
                                                          {val.percent
                                                            ? `(${val.percent}%)`
                                                            : ""}{" "}
                                                          <br />
                                                        </span>
                                                      ))}
                                                    </Typography>
                                                  </Grid>

                                                  {/* Service */}
                                                  {item.benefit_description && (
                                                    <Grid item xs={12}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Service
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {
                                                          item.benefit_description
                                                        }
                                                      </Typography>
                                                    </Grid>
                                                  )}

                                                  {/* Notes */}
                                                  {item.benefit_notes && (
                                                    <Grid item xs={12}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Notes
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {item.benefit_notes}
                                                      </Typography>
                                                    </Grid>
                                                  )}
                                                </Grid>
                                              </Paper>
                                            ),
                                          )}
                                        </Box>
                                      )}
                                    </AccordionDetails>
                                  </Accordion>
                                  <Accordion
                                    sx={{
                                      borderRadius: "12px",
                                      mt: 1,
                                      backgroundColor: "#FEE2E2",
                                    }}
                                  >
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                    >
                                      <Typography
                                        fontSize="0.9rem"
                                        fontWeight={600}
                                      >
                                        Family Deductibles
                                      </Typography>
                                    </AccordionSummary>

                                    <AccordionDetails sx={{ p: 1 }}>
                                      {familyDeductibles.length === 0 ? (
                                        <Typography fontSize="0.85rem">
                                          No Deductibles Found
                                        </Typography>
                                      ) : (
                                        <Box>
                                          {familyDeductibles.map(
                                            (item, index) => (
                                              <Paper
                                                key={index}
                                                elevation={1}
                                                sx={{
                                                  mb: 0.75,
                                                  p: 1,
                                                  borderRadius: "10px",
                                                  backgroundColor: "#fff",
                                                }}
                                              >
                                                <Grid container spacing={0.5}>
                                                  {/* Colored Label for Deductible Type */}
                                                  <Grid item xs={12}>
                                                    <Typography
                                                      fontSize="0.8rem"
                                                      fontWeight={600}
                                                      sx={{
                                                        color:
                                                          getDeductibleColor(
                                                            item,
                                                          ),
                                                        backgroundColor:
                                                          "#f3f4f6",
                                                        px: 0.75,
                                                        py: 0.25,
                                                        borderRadius: "6px",
                                                        display: "inline-block",
                                                        mb: 0.5,
                                                      }}
                                                    >
                                                      {getDeductibleType(item)}{" "}
                                                      {item.benefit_coverage_description
                                                        ?.toLowerCase()
                                                        .includes(
                                                          "out of pocket",
                                                        )
                                                        ? "(OOP Max)"
                                                        : "Deductible"}
                                                    </Typography>
                                                  </Grid>

                                                  {/* Network */}
                                                  <Grid item xs={5}>
                                                    <Typography
                                                      fontSize="0.8rem"
                                                      fontWeight={600}
                                                    >
                                                      Network
                                                    </Typography>
                                                    <Typography fontSize="0.8rem">
                                                      {getNetworkLabel(
                                                        item.inplan_network,
                                                      )}
                                                    </Typography>
                                                  </Grid>

                                                  {/* Amount / Percent by Period */}
                                                  <Grid item xs={7}>
                                                    <Typography
                                                      fontSize="0.8rem"
                                                      fontWeight={600}
                                                    >
                                                      Amount / Percent
                                                    </Typography>
                                                    <Typography fontSize="0.8rem">
                                                      {Object.entries(
                                                        item.periods || {},
                                                      ).map(([period, val]) => (
                                                        <span key={period}>
                                                          {period}: $
                                                          {val.amount}{" "}
                                                          {val.percent
                                                            ? `(${val.percent}%)`
                                                            : ""}{" "}
                                                          <br />
                                                        </span>
                                                      ))}
                                                    </Typography>
                                                  </Grid>

                                                  {/* Service */}
                                                  {item.benefit_description && (
                                                    <Grid item xs={12}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Service
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {
                                                          item.benefit_description
                                                        }
                                                      </Typography>
                                                    </Grid>
                                                  )}

                                                  {/* Notes */}
                                                  {item.benefit_notes && (
                                                    <Grid item xs={12}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Notes
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {item.benefit_notes}
                                                      </Typography>
                                                    </Grid>
                                                  )}
                                                </Grid>
                                              </Paper>
                                            ),
                                          )}
                                        </Box>
                                      )}
                                    </AccordionDetails>
                                  </Accordion>
                                  <Accordion
                                    sx={{
                                      borderRadius: "12px",
                                      mt: 1,
                                      backgroundColor: "#E0F2FE",
                                    }}
                                  >
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                    >
                                      <Typography
                                        fontSize="0.9rem"
                                        fontWeight={600}
                                      >
                                        OOP Max Deductibles
                                      </Typography>
                                    </AccordionSummary>

                                    <AccordionDetails sx={{ p: 1 }}>
                                      {oopMaxDeductibles.length === 0 ? (
                                        <Typography fontSize="0.85rem">
                                          No Deductibles Found
                                        </Typography>
                                      ) : (
                                        <Box>
                                          {oopMaxDeductibles.map(
                                            (item, index) => (
                                              <Paper
                                                key={index}
                                                elevation={1}
                                                sx={{
                                                  mb: 0.75,
                                                  p: 1,
                                                  borderRadius: "10px",
                                                  backgroundColor: "#fff",
                                                }}
                                              >
                                                <Grid container spacing={0.5}>
                                                  {/* Colored Label for Deductible Type */}
                                                  <Grid item xs={12}>
                                                    <Typography
                                                      fontSize="0.8rem"
                                                      fontWeight={600}
                                                      sx={{
                                                        color:
                                                          getDeductibleColor(
                                                            item,
                                                          ),
                                                        backgroundColor:
                                                          "#f3f4f6",
                                                        px: 0.75,
                                                        py: 0.25,
                                                        borderRadius: "6px",
                                                        display: "inline-block",
                                                        mb: 0.5,
                                                      }}
                                                    >
                                                      {getDeductibleType(item)}{" "}
                                                      {item.benefit_coverage_description
                                                        ?.toLowerCase()
                                                        .includes(
                                                          "out of pocket",
                                                        )
                                                        ? "(OOP Max)"
                                                        : "Deductible"}
                                                    </Typography>
                                                  </Grid>

                                                  {/* Network */}
                                                  <Grid item xs={5}>
                                                    <Typography
                                                      fontSize="0.8rem"
                                                      fontWeight={600}
                                                    >
                                                      Network
                                                    </Typography>
                                                    <Typography fontSize="0.8rem">
                                                      {getNetworkLabel(
                                                        item.inplan_network,
                                                      )}
                                                    </Typography>
                                                  </Grid>

                                                  {/* Amount / Percent by Period */}
                                                  <Grid item xs={7}>
                                                    <Typography
                                                      fontSize="0.8rem"
                                                      fontWeight={600}
                                                    >
                                                      Amount / Percent
                                                    </Typography>
                                                    <Typography fontSize="0.8rem">
                                                      {Object.entries(
                                                        item.periods || {},
                                                      ).map(([period, val]) => (
                                                        <span key={period}>
                                                          {period}: $
                                                          {val.amount}{" "}
                                                          {val.percent
                                                            ? `(${val.percent}%)`
                                                            : ""}{" "}
                                                          <br />
                                                        </span>
                                                      ))}
                                                    </Typography>
                                                  </Grid>

                                                  {/* Service */}
                                                  {item.benefit_description && (
                                                    <Grid item xs={12}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Service
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {
                                                          item.benefit_description
                                                        }
                                                      </Typography>
                                                    </Grid>
                                                  )}

                                                  {/* Notes */}
                                                  {item.benefit_notes && (
                                                    <Grid item xs={12}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Notes
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {item.benefit_notes}
                                                      </Typography>
                                                    </Grid>
                                                  )}
                                                </Grid>
                                              </Paper>
                                            ),
                                          )}
                                        </Box>
                                      )}
                                    </AccordionDetails>
                                  </Accordion>
                                </>
                              )}
                            </AccordionDetails>
                          </Accordion>

                          {/* ================= Patient Benefits ================= */}
                          <Accordion
                            sx={{
                              borderRadius: "12px",
                              backgroundColor: "#fff7ed",
                              mt: 1,
                            }}
                          >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <Typography fontSize="0.9rem" fontWeight={600}>
                                Benefits
                              </Typography>
                            </AccordionSummary>

                            <AccordionDetails sx={{ p: 1 }}>
                              {patientBenefits.length === 0 ? (
                                <Typography fontSize="0.85rem">
                                  No Benefits Found
                                </Typography>
                              ) : (
                                <Box>
                                  {patientBenefits.map((item, index) => (
                                    <Paper
                                      key={index}
                                      elevation={1}
                                      sx={{
                                        mb: 0.75,
                                        p: 1,
                                        borderRadius: "10px",
                                        backgroundColor: "#f9fafb",
                                        border: "1px solid #e5e7eb",
                                      }}
                                    >
                                      <Grid container spacing={0.5}>
                                        {/* Service */}
                                        {item.benefit_description && (
                                          <Grid item xs={12}>
                                            <Typography
                                              fontSize="0.8rem"
                                              fontWeight={600}
                                            >
                                              Service
                                            </Typography>
                                            <Typography fontSize="0.8rem">
                                              {item.benefit_description}
                                            </Typography>
                                          </Grid>
                                        )}

                                        {/* Network */}
                                        {item.inplan_network && (
                                          <Grid item xs={6}>
                                            <Typography
                                              fontSize="0.8rem"
                                              fontWeight={600}
                                            >
                                              Network
                                            </Typography>
                                            <Typography fontSize="0.8rem">
                                              {getNetworkLabel(
                                                item.inplan_network,
                                              )}
                                            </Typography>
                                          </Grid>
                                        )}

                                        {/* Amount / Percent by Period */}
                                        <Grid item xs={6}>
                                          <Typography
                                            fontSize="0.8rem"
                                            fontWeight={600}
                                          >
                                            Amount / Percent
                                          </Typography>
                                          <Typography fontSize="0.8rem">
                                            {Object.entries(
                                              item.periods || {},
                                            ).map(([period, val]) => (
                                              <span key={period}>
                                                {period}: ${val.amount}{" "}
                                                {val.percent
                                                  ? `(${val.percent}%)`
                                                  : ""}{" "}
                                                <br />
                                              </span>
                                            ))}
                                          </Typography>
                                        </Grid>

                                        {/* Plan Type */}
                                        {item.insurance_type_description && (
                                          <Grid item xs={12}>
                                            <Typography
                                              fontSize="0.8rem"
                                              fontWeight={600}
                                            >
                                              Plan Type
                                            </Typography>
                                            <Typography fontSize="0.8rem">
                                              {item.insurance_type_description}
                                            </Typography>
                                          </Grid>
                                        )}

                                        {/* Notes */}
                                        {item.benefit_notes && (
                                          <Grid item xs={12}>
                                            <Typography
                                              fontSize="0.8rem"
                                              fontWeight={600}
                                            >
                                              Additional Notes
                                            </Typography>
                                            <Typography fontSize="0.8rem">
                                              {item.benefit_notes}
                                            </Typography>
                                          </Grid>
                                        )}
                                      </Grid>
                                    </Paper>
                                  ))}
                                </Box>
                              )}
                            </AccordionDetails>
                          </Accordion>

                          {/* ================= Co-Insurance & Copayment ================= */}
                          <Accordion
                            sx={{
                              borderRadius: "12px",
                              mt: 1,
                              backgroundColor: "#ecfeff",
                            }}
                          >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <Typography fontSize="0.9rem" fontWeight={600}>
                                Co-Insurance & Copayment
                              </Typography>
                            </AccordionSummary>

                            <AccordionDetails sx={{ p: 1 }}>
                              {coInsuranceBenefits.length === 0 ? (
                                <Typography fontSize="0.85rem">
                                  No Co-Insurance / Copayment Found
                                </Typography>
                              ) : (
                                // <Box>
                                //   {coInsuranceBenefits.map((item, index) => (
                                //     <Paper
                                //       key={index}
                                //       elevation={1}
                                //       sx={{
                                //         mb: 0.75,
                                //         p: 1,
                                //         borderRadius: "10px",
                                //         backgroundColor: "#ffffff",
                                //         border: "1px solid #bae6fd",
                                //       }}
                                //     >
                                //       <Grid container spacing={0.5}>
                                //         {/* Service */}
                                //         {item.benefit_description && (
                                //           <Grid item xs={6}>
                                //             <Typography fontSize="0.8rem" fontWeight={600}>
                                //               Service
                                //             </Typography>
                                //             <Typography fontSize="0.8rem">
                                //               {item.benefit_description}
                                //             </Typography>
                                //           </Grid>
                                //         )}

                                //         {/* Network */}
                                //         {item.inplan_network && (
                                //           <Grid item xs={6}>
                                //             <Typography fontSize="0.8rem" fontWeight={600}>
                                //               Network
                                //             </Typography>
                                //             <Typography fontSize="0.8rem">
                                //               {getNetworkLabel(item.inplan_network)}
                                //             </Typography>
                                //           </Grid>
                                //         )}

                                //         {/* Coverage Type */}
                                //         {item.benefit_coverage_description && (
                                //           <Grid item xs={6}>
                                //             <Typography fontSize="0.8rem" fontWeight={600}>
                                //               Type
                                //             </Typography>
                                //             <Typography fontSize="0.8rem">
                                //               {item.benefit_coverage_description}
                                //             </Typography>
                                //           </Grid>
                                //         )}

                                //         {/* Amount / Percent by Period */}
                                //         <Grid item xs={6}>
                                //           <Typography fontSize="0.8rem" fontWeight={600}>
                                //             Amount / Percent
                                //           </Typography>
                                //           <Typography fontSize="0.8rem">
                                //             {Object.entries(item.periods || {}).map(([period, val]) => (
                                //               <span key={period}>
                                //                 {period}: ${val.amount} {val.percent ? `(${val.percent}%)` : ""} <br />
                                //               </span>
                                //             ))}
                                //           </Typography>
                                //         </Grid>

                                //         {/* Plan Type */}
                                //         {item.insurance_type_description && (
                                //           <Grid item xs={12}>
                                //             <Typography fontSize="0.8rem" fontWeight={600}>
                                //               Plan Type
                                //             </Typography>
                                //             <Typography fontSize="0.8rem">
                                //               {item.insurance_type_description}
                                //             </Typography>
                                //           </Grid>
                                //         )}

                                //         {/* Notes */}
                                //         {item.benefit_notes && (
                                //           <Grid item xs={12}>
                                //             <Typography fontSize="0.8rem" fontWeight={600}>
                                //               Notes
                                //             </Typography>
                                //             <Typography fontSize="0.8rem">{item.benefit_notes}</Typography>
                                //           </Grid>
                                //         )}
                                //       </Grid>
                                //     </Paper>
                                //   ))}
                                // </Box>
                                <>
                                  <Accordion
                                    sx={{
                                      borderRadius: "12px",
                                      mt: 1,
                                      backgroundColor: "#FEF3C7",
                                    }}
                                  >
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                    >
                                      <Typography
                                        fontSize="0.9rem"
                                        fontWeight={600}
                                      >
                                        IN Newtwork
                                      </Typography>
                                    </AccordionSummary>

                                    <AccordionDetails sx={{ p: 1 }}>
                                      {inNetworkCoinsurance .length === 0 ? (
                                        <Typography fontSize="0.85rem">
                                          No Record Found
                                        </Typography>
                                      ) : (
                                        <Box>
                                          {inNetworkCoinsurance .map(
                                            (item, index) => (
                                              <Paper
                                                key={index}
                                                elevation={1}
                                                sx={{
                                                  mb: 0.75,
                                                  p: 1,
                                                  borderRadius: "10px",
                                                  backgroundColor: "#ffffff",
                                                  border: "1px solid #bae6fd",
                                                }}
                                              >
                                                <Grid container spacing={0.5}>
                                                  {/* Service */}
                                                  {item.benefit_description && (
                                                    <Grid item xs={6}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Service
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {
                                                          item.benefit_description
                                                        }
                                                      </Typography>
                                                    </Grid>
                                                  )}

                                                  {/* Network */}
                                                  {item.inplan_network && (
                                                    <Grid item xs={6}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Network
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {getNetworkLabel(
                                                          item.inplan_network,
                                                        )}
                                                      </Typography>
                                                    </Grid>
                                                  )}

                                                  {/* Coverage Type */}
                                                  {item.benefit_coverage_description && (
                                                    <Grid item xs={6}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Type
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {
                                                          item.benefit_coverage_description
                                                        }
                                                      </Typography>
                                                    </Grid>
                                                  )}

                                                  {/* Amount / Percent by Period */}
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      fontSize="0.8rem"
                                                      fontWeight={600}
                                                    >
                                                      Amount / Percent
                                                    </Typography>
                                                    {/* <Typography fontSize="0.8rem">
                                                      {Object.entries(
                                                        item.periods || {},
                                                      ).map(([period, val]) => (
                                                        <span key={period}>
                                                          {period}: $
                                                          {val.amount}{" "}
                                                          {val.percent
                                                            ? `(${val.percent}%)`
                                                            : ""}{" "}
                                                          <br />
                                                        </span>
                                                      ))}
                                                    </Typography> */}
                                                    <Typography fontSize="0.8rem">
    {item.benefit_percent != null && item.benefit_percent !== ""
      ? `${item.benefit_percent}%`
      : item.benefit_amount != null && item.benefit_amount !== 0
      ? `$${item.benefit_amount}`
      : "N/A"}
  </Typography>
                                                  </Grid>

                                                  {/* Plan Type */}
                                                  {item.insurance_type_description && (
                                                    <Grid item xs={12}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Plan Type
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {
                                                          item.insurance_type_description
                                                        }
                                                      </Typography>
                                                    </Grid>
                                                  )}

                                                  {/* Notes */}
                                                  {item.benefit_notes && (
                                                    <Grid item xs={12}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Notes
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {item.benefit_notes}
                                                      </Typography>
                                                    </Grid>
                                                  )}
                                                </Grid>
                                              </Paper>
                                            ),
                                          )}
                                        </Box>
                                      )}
                                    </AccordionDetails>
                                  </Accordion>
                                  <Accordion
                                    sx={{
                                      borderRadius: "12px",
                                      mt: 1,
                                      backgroundColor: "#FEE2E2",
                                    }}
                                  >
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                    >
                                      <Typography
                                        fontSize="0.9rem"
                                        fontWeight={600}
                                      >
                                        Out of Newtwork
                                      </Typography>
                                    </AccordionSummary>

                                    <AccordionDetails sx={{ p: 1 }}>
                                      {outOfNetworkCoinsurance.length === 0 ? (
                                        <Typography fontSize="0.85rem">
                                          No Record Found
                                        </Typography>
                                      ) : (
                                        <Box>
                                          {outOfNetworkCoinsurance.map(
                                            (item, index) => (
                                              <Paper
                                                key={index}
                                                elevation={1}
                                                sx={{
                                                  mb: 0.75,
                                                  p: 1,
                                                  borderRadius: "10px",
                                                  backgroundColor: "#ffffff",
                                                  border: "1px solid #bae6fd",
                                                }}
                                              >
                                                <Grid container spacing={0.5}>
                                                  {/* Service */}
                                                  {item.benefit_description && (
                                                    <Grid item xs={6}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Service
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {
                                                          item.benefit_description
                                                        }
                                                      </Typography>
                                                    </Grid>
                                                  )}

                                                  {/* Network */}
                                                  {item.inplan_network && (
                                                    <Grid item xs={6}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Network
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {getNetworkLabel(
                                                          item.inplan_network,
                                                        )}
                                                      </Typography>
                                                    </Grid>
                                                  )}

                                                  {/* Coverage Type */}
                                                  {item.benefit_coverage_description && (
                                                    <Grid item xs={6}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Type
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {
                                                          item.benefit_coverage_description
                                                        }
                                                      </Typography>
                                                    </Grid>
                                                  )}

                                                  {/* Amount / Percent by Period */}
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      fontSize="0.8rem"
                                                      fontWeight={600}
                                                    >
                                                      Amount / Percent
                                                    </Typography>
                                                    <Typography fontSize="0.8rem">
    {item.benefit_percent != null && item.benefit_percent !== ""
      ? `${item.benefit_percent}%`
      : item.benefit_amount != null && item.benefit_amount !== 0
      ? `$${item.benefit_amount}`
      : "N/A"}
  </Typography>
                                                  </Grid>

                                                  {/* Plan Type */}
                                                  {item.insurance_type_description && (
                                                    <Grid item xs={12}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Plan Type
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {
                                                          item.insurance_type_description
                                                        }
                                                      </Typography>
                                                    </Grid>
                                                  )}

                                                  {/* Notes */}
                                                  {item.benefit_notes && (
                                                    <Grid item xs={12}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Notes
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {item.benefit_notes}
                                                      </Typography>
                                                    </Grid>
                                                  )}
                                                </Grid>
                                              </Paper>
                                            ),
                                          )}
                                        </Box>
                                      )}
                                    </AccordionDetails>
                                  </Accordion>
                                  <Accordion
                                    sx={{
                                      borderRadius: "12px",
                                      mt: 1,
                                      backgroundColor: "#E0F2FE",
                                    }}
                                  >
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                    >
                                      <Typography
                                        fontSize="0.9rem"
                                        fontWeight={600}
                                      >
                                        Conditional Newtwork
                                      </Typography>
                                    </AccordionSummary>

                                    <AccordionDetails sx={{ p: 1 }}>
                                      {conditionalNetworkCoinsurance.length === 0 ? (
                                        <Typography fontSize="0.85rem">
                                          No Record Found
                                        </Typography>
                                      ) : (
                                        <Box>
                                          {conditionalNetworkCoinsurance.map(
                                            (item, index) => (
                                              <Paper
                                                key={index}
                                                elevation={1}
                                                sx={{
                                                  mb: 0.75,
                                                  p: 1,
                                                  borderRadius: "10px",
                                                  backgroundColor: "#ffffff",
                                                  border: "1px solid #bae6fd",
                                                }}
                                              >
                                                <Grid container spacing={0.5}>
                                                  {/* Service */}
                                                  {item.benefit_description && (
                                                    <Grid item xs={6}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Service
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {
                                                          item.benefit_description
                                                        }
                                                      </Typography>
                                                    </Grid>
                                                  )}

                                                  {/* Network */}
                                                  {item.inplan_network && (
                                                    <Grid item xs={6}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Network
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {getNetworkLabel(
                                                          item.inplan_network,
                                                        )}
                                                      </Typography>
                                                    </Grid>
                                                  )}

                                                  {/* Coverage Type */}
                                                  {item.benefit_coverage_description && (
                                                    <Grid item xs={6}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Type
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {
                                                          item.benefit_coverage_description
                                                        }
                                                      </Typography>
                                                    </Grid>
                                                  )}

                                                  {/* Amount / Percent by Period */}
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      fontSize="0.8rem"
                                                      fontWeight={600}
                                                    >
                                                      Amount / Percent
                                                    </Typography>
                                                    <Typography fontSize="0.8rem">
    {item.benefit_percent != null && item.benefit_percent !== ""
      ? `${item.benefit_percent}%`
      : item.benefit_amount != null && item.benefit_amount !== 0
      ? `$${item.benefit_amount}`
      : "N/A"}
  </Typography>
                                                  </Grid>

                                                  {/* Plan Type */}
                                                  {item.insurance_type_description && (
                                                    <Grid item xs={12}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Plan Type
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {
                                                          item.insurance_type_description
                                                        }
                                                      </Typography>
                                                    </Grid>
                                                  )}

                                                  {/* Notes */}
                                                  {item.benefit_notes && (
                                                    <Grid item xs={12}>
                                                      <Typography
                                                        fontSize="0.8rem"
                                                        fontWeight={600}
                                                      >
                                                        Notes
                                                      </Typography>
                                                      <Typography fontSize="0.8rem">
                                                        {item.benefit_notes}
                                                      </Typography>
                                                    </Grid>
                                                  )}
                                                </Grid>
                                              </Paper>
                                            ),
                                          )}
                                        </Box>
                                      )}
                                    </AccordionDetails>
                                  </Accordion>
                                </>
                              )}
                            </AccordionDetails>
                          </Accordion>
                        </Box>
                      </Paper>
                    )
                  )}

                  {/* ================= ELIGIBILITY LOGS GRID ================= */}
                  {isLoading ? (
                    <Box textAlign="center" mt={5}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <Box sx={{ height: 200, width: "100%" }}>
                      <Typography fontWeight={600} mb={1}>
                        Eligibility Logs
                      </Typography>
                      {rows === null || rows.length === 0 ? (
                        <Typography>No Record found</Typography>
                      ) : (
                        <DataGrid
                          rows={rows}
                          columns={columns}
                          classes={gridClasses}
                          rowHeight={30}
                          pagination
                          pageSizeOptions={[25]}
                          initialState={{
                            pagination: {
                              paginationModel: {
                                page: 0,
                                pageSize: 25,
                              },
                            },
                          }}
                          sx={gridRowStyle}
                        />
                      )}
                    </Box>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          )}
        </Grid>
        <Grid item xs={12} lg={12} sm={12} style={{ marginTop: "1.5rem" }}>
          {props.callingFrom == "Patient" || props.callingFrom == true ? (
            <></>
          ) : (
            <>
              <Button
                className="Button"
                onClick={handleCancel}
                variant="gradient"
                disabled={submitting}
                style={{
                  marginTop: "0px",
                  marginBottom: "10px",
                  float: "right",
                  marginLeft: "10px",
                  width: "90px",
                  height: "35px",
                  color: "white",
                  fontSize: "14px",
                }}
              >
                <CancelOutlinedIcon
                  fontSize="medium"
                  style={{ color: "white", paddingRight: "5px" }}
                ></CancelOutlinedIcon>
                Cancel
              </Button>
            </>
          )}

          <Button
            className="Button"
            onClick={handleSubmit(onSubmit)}
            variant="gradient"
            disabled={disable == true ? true : false}
            style={{
              marginTop: "0px",
              marginBottom: "10px",
              float: "right",
              marginLeft: "auto",
              width: "90px",
              height: "35px",
              backgroundColor: "#A574FD",
              color: "white",
              fontSize: "14px",
            }}
          >
            <SaveOutlinedIcon
              fontSize="medium"
              style={{ color: "white", paddingRight: "5px" }}
            ></SaveOutlinedIcon>
            Save
          </Button>
        </Grid>
        {/* </Container> */}
      </div>
    </React.Fragment>
  );
};

export default Demographics;
